import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SideBar from "../../components/b2b/SideBar";
import Header from "../../components/landingPage/Header";
import copy from "copy-to-clipboard";
import { useState } from "react";
import ManageBookingItem from "../../components/b2b/ManageBooking/ManageBookingItem";
import { ClockIcon, DownloadIcon, FilterIcon } from "@heroicons/react/solid";
import {
  faCircleExclamation,
  faClose,
  faRotate,
  faWarning,
} from "@fortawesome/free-solid-svg-icons";
import {
  faCheck,
  faChevronLeft,
  faChevronRight,
  faNewspaper,
  faPlus,
} from "@fortawesome/fontawesome-free-solid";
import { Drawer, IconButton, Skeleton, Tooltip } from "@mui/material";
import Calendar from "react-calendar";
import moment from "moment";
import momenttz from "moment-timezone";
import { Link } from "react-router-dom";
import {
  getAllSearchedbookings,
  setaffiliatePaymentPendingBookings,
  setGroupBooking,
  setJobsTab,
  setPageCount,
  setPageNext,
  setPagePrev,
  setSearch,
  setSearchedBookingCount,
} from "../../redux/app/booking/booking-slice";
import "./ManageBooking.css";
import Select from "react-select";
import {
  Close,
  Layers,
  LayersClear,
  LibraryAdd,
  Save,
} from "@material-ui/icons";
import axios from "axios";
import { useCallback } from "react";
import { CreditCard, Receipt } from "@mui/icons-material";
import { LoadingSpinner } from "./FinAmmendment";

const ManageBooking = () => {
  const dispatch = useDispatch();
  const { token, user } = useSelector((state) => state.auth);
  const { settings } = useSelector((state) => state.settings);
  const [affiliateName, setaffiliateName] = useState();
  const [bookingStatus, setBookingStatus] = useState("ALL BOOKINGS");
  const {
    allBookings,
    allSearchedBookings,
    searchedBookingCount,
    paginatedBookingCount,
    pageCount,
    totalBookingCount,
    search,
    jobsTab,
    jobsForTodayBookings,
    jobsForTomorrowBookings,
    bookingIsloading,
    unassignedJobs,
    groupBooking,
    groupIds,
    totalTomorrowBookingsCount,
    paginatedTomorrowBookingsCount,
    totalTodayBookingsCount,
    paginatedTodayBookingsCount,
    totalunassignedBookingsCount,
    paginatedunassignedBookingsCount,
    pobBookings,
    affiliatePaymentPendingBookings,
    ammendmentFinanceCount,
    ammendmentOpsCount,
  } = useSelector((state) => state.booking);
  const { allCompany } = useSelector((state) => state.company);
  const { activeAffiliates } = useSelector((state) => state.affiliate);

  const [assignAffiliateDetail, setassignAffiliateDetail] = useState();
  const [assignAffiliateMail, setassignAffiliateMail] = useState();
  const [affiliatedetailsAssigned, setaffiliatedetailsAssigned] = useState([]);
  const [docketarr, setdocketarr] = useState([]);
  const [assignedAffiliateSendVoucher, setassignedAffiliateSendVoucher] =
    useState([]);
  const [paymentPendings, setpaymentPendings] = useState("false");
  const [paymentPendingsTw, setpaymentPendingsTw] = useState("false");
  const [isGroup, setisGroup] = useState(false);
  const [groupIn, setgroupIn] = useState(false);
  const [groupOut, setgroupOut] = useState(false);
  const [invoiceGroup, setinvoiceGroup] = useState(false);
  const [invoiceId, setinvoiceId] = useState();
  const [groupId, setgroupId] = useState();

  console.log("search===>", search);

  useEffect(() => {
    dispatch({
      type: "GET_GROUP_IDS",
      payload: { token },
    });
    dispatch({
      type: "GET_FINANCE_UNCHECKED_AMMENDMENT_COUNT",
      payload: {
        token: token,
      },
    });
    dispatch({
      type: "GET_UNCHECKED_OPS_AMMENDMENT_COUNT",
      payload: {
        token: token,
      },
    });
  }, []);

  useEffect(() => {
    dispatch(setPageCount({ pageCount: 1 }));
  }, [jobsTab]);

  const [userCompany, setUserCompany] = useState();
  const [downloadStart, setDownloadStart] = useState(false);

  const downloadReportHandler = async () => {
    setDownloadStart(true);
    try {
      // const csvurl = `http://localhost:5000/api/v1/bookings/downloadCSVBooking?userName=${user?.userName?.toString()}&viewBookingPermisision=${user?.permission?.manageBooking?.viewBooking?.permission?.toString()}&companyId=${user?.company?._id?.toString()}&userRole=${user?.role?.toString()}`;

      const csvurl = `${
        process.env.REACT_APP_BASE_URL
      }/bookings/downloadCSVBooking?userName=${user?.userName?.toString()}&viewBookingPermisision=${user?.permission?.manageBooking?.viewBooking?.permission?.toString()}&companyId=${user?.company?._id?.toString()}&userRole=${user?.role?.toString()}${`${
        search.bookingId ? `&bookingId=${search.bookingId}` : ""
      }${search.userName ? `&userNameQuery=${search.userName}` : ""}${
        search.bookingStatus ? `&bookingStatus=${search.bookingStatus}` : ""
      }${search.paymentStatus ? `&paymentStatus=${search.paymentStatus}` : ""}${
        search.affiliateName ? `&affiliateName=${search.affiliateName}` : ""
      }${search.companyName ? `&companyName=${search.companyName}` : ""}${
        search.passengerName ? `&customerName=${search.passengerName}` : ""
      }${search.DateType ? `&DateType=${dateType}` : ""}${
        search.createdDateStart
          ? `&createdDateStart=${search.createdDateStart}`
          : ""
      }${
        search.createdDateEnd ? `&createdDateEnd=${search.createdDateEnd}` : ""
      }${
        search.travelStartDate
          ? `&travelStartDate=${search.travelStartDate}`
          : ""
      }${search.travelEndDate ? `&travelEndDate=${search.travelEndDate}` : ""}${
        search.passengerNumber
          ? `&passengerNumber=${search.passengerNumber}`
          : ""
      }${search.invoiceNumber ? `&invoiceNumber=${search.invoiceNumber}` : ""}${
        search.invoicedStatus ? `&invoicedStatus=${search.invoicedStatus}` : ""
      }${
        search.affiliateNumber
          ? `&affiliateNumber=${search.affiliateNumber}`
          : ""
      }${search.driverName ? `&driverName=${search.driverName}` : ""}${
        search.driverNumber ? `&driverNumber=${search.driverNumber}` : ""
      }${search.groupId ? `&groupId=${search.groupId}` : ""}${
        search.quoteby ? `&quoteby=${search.quoteby}` : ""
      }`}`;

      const response = await axios.get(
        csvurl,

        {
          responseType: "stream",
          // onDownloadProgress: (progressEvent) => {
          //   console.log("progressEvent.loaded====>", progressEvent.loaded);
          //   console.log("progressEvent.loaded**====>", progressEvent);
          //   console.log("progressEvent.total====>", progressEvent.total);
          //   const percentCompleted = Math.round(
          //     (progressEvent.loaded * 100) / progressEvent.total
          //   );

          // },
        }
      );
      // console.log("response====>", response);

      const blob = new Blob([response.data], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);

      // Create a link and click it to trigger download
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "bookings.csv");
      document.body.appendChild(link);
      link.click();

      // Clean up
      window.URL.revokeObjectURL(url);

      if (response.status === 200) {
        setDownloadStart(false);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // allBookings.map((b) => {});
  useEffect(() => {
    // dispatch({
    //   type: "GET_ALL_BOOKINGS",
    //   payload: { token: token, pageCount: pageCount },
    // });
    // dispatch({
    //   type: "TOTAL_BOOKING_COUNT",
    //   payload: { token: token },
    // });

    if (user) {
      dispatch({
        type: "GET_ALL_BOOKINGS",
        payload: {
          // token: token,
          pageCount: pageCount?.toString(),
          userName: user?.userName?.toString(),
          viewBookingPermisision:
            user?.permission?.manageBooking?.viewBooking?.permission?.toString(),
          companyId: user?.company?._id?.toString(),
          userRole: user?.role?.toString(),
        },
      });
    }
  }, []);

  useEffect(() => {
    if (user) {
      dispatch({
        type: "AFFILIATE_PAYMENT_PENDING",
        payload: {
          userRole: user?.role?.toString(),
          page: pageCount?.toString(),
          checkPendingPay: true,
        },
      });
    }
  }, [user]);

  useEffect(() => {
    if (paymentPendings === "true") {
      dispatch({
        type: "JOBS_FOR_TODAY",
        payload: {
          userRole: user?.role?.toString(),
          page: pageCount?.toString(),
          checkPendingPay: paymentPendings,
        },
      });
    } else if (paymentPendings === "false") {
      dispatch({
        type: "JOBS_FOR_TODAY",
        payload: {
          userRole: user?.role?.toString(),
          page: pageCount?.toString(),
          checkPendingPay: paymentPendings,
        },
      });
    }

    if (paymentPendingsTw === "true") {
      dispatch({
        type: "JOBS_FOR_TOMORROW",
        payload: {
          userRole: user?.role?.toString(),
          page: pageCount?.toString(),
          checkPendingPay: paymentPendingsTw,
        },
      });
    } else if (paymentPendingsTw === "false") {
      dispatch({
        type: "JOBS_FOR_TOMORROW",
        payload: {
          userRole: user?.role?.toString(),
          page: pageCount?.toString(),
          checkPendingPay: paymentPendingsTw,
        },
      });
    }
  }, [paymentPendings, paymentPendingsTw]);

  const getAllTypeOfBookings = useCallback(() => {
    if (user) {
      dispatch({
        type: "JOBS_FOR_TODAY",
        payload: {
          userRole: user?.role?.toString(),
          page: pageCount?.toString(),
          checkPendingPay: paymentPendings,
        },
      });
      dispatch({
        type: "JOBS_FOR_TOMORROW",
        payload: {
          userRole: user?.role?.toString(),
          page: pageCount?.toString(),
          checkPendingPay: paymentPendingsTw,
        },
      });
      dispatch({
        type: "UNASSIGNED_JOBS",
        payload: {
          userRole: user?.role?.toString(),
          page: pageCount?.toString(),
        },
      });
      dispatch({
        type: "POB_BOOKINGS_LIST",
        payload: {
          token: token,
        },
      });
    }
  }, [user]);

  useEffect(() => {
    getAllTypeOfBookings();
  }, [user]);

  // useEffect(() => {
  //   if (jobsTab.allBookings && user) {
  //     dispatch({
  //       type: "GET_ALL_BOOKINGS",
  //       payload: {
  //         // token: token,
  //         pageCount: pageCount?.toString(),
  //         userName: user?.userName?.toString(),
  //         viewBookingPermisision:
  //         user?.permission?.manageBooking?.viewBooking?.permission?.toString(),
  //         companyId: user?.company?._id?.toString(),
  //         userRole: user?.role?.toString(),
  //       },
  //     });
  //   }
  // }, [dispatch, pageCount, user]);

  useEffect(() => {
    // dispatch({
    //   type: "GET_ALL_COMPANY",
    //   payload: { token },
    // });

    // dispatch({
    //   type: "JOBS_FOR_TODAY",
    //   payload: { token },
    // });
    // dispatch({
    //   type: "JOBS_FOR_TOMORROW",
    //   payload: { token },
    // });
    // dispatch({
    //   type: "UNASSIGNED_JOBS",
    //   payload: { token },
    // });

    if (user) {
      if (jobsTab.jobsToday) {
        dispatch({
          type: "JOBS_FOR_TODAY",
          payload: {
            userRole: user?.role?.toString(),
            page: pageCount?.toString(),
          },
        });
      }

      if (jobsTab.jobsTomorrow) {
        dispatch({
          type: "JOBS_FOR_TOMORROW",
          payload: {
            userRole: user?.role?.toString(),
            page: pageCount?.toString(),
          },
        });
      }
      if (jobsTab.unassignedJobs) {
        dispatch({
          type: "UNASSIGNED_JOBS",
          payload: {
            userRole: user?.role?.toString(),
            page: pageCount?.toString(),
          },
        });
      }
    }
  }, [dispatch, user, pageCount]);

  useEffect(() => {
    allCompany?.map((company) => {
      return company?.users?.map((companyuser) => {
        return (
          companyuser?.userName === user?.userName && setUserCompany(company)
        );
      });
    });
  }, [user, allCompany]);

  let bookingChildLevelList = [];

  useEffect(() => {
    allBookings?.forEach((booking) => {
      userCompany?.company?.forEach((userCom) =>
        allCompany?.forEach(
          (company) =>
            (company?._id === userCom?._id ||
              company?._id === userCompany?._id) &&
            company?.users.forEach(
              (user) =>
                booking?.userName === user?.userName &&
                bookingChildLevelList.push(booking?._id)
            )
        )
      );
    });
  }, []);

  const [isSearch, setIsSearch] = useState(false);
  const [dateType, setdateType] = useState("BOOKING_DATE");
  const [drawerOpen, setdrawerOpen] = useState(false);
  const [calenderView, setcalenderView] = useState(false);
  const [dateValue, setDateValue] = useState(new Date());

  console.log("dateType===>", dateType);
  const HandleChange = (e) => {
    setSearch({ ...search, [e.target.name]: e.target.value });
  };

  const [isBulkAssign, setisBulkAssign] = useState(false);

  useEffect(() => {
    if (jobsTab.allBookings && user) {
      if (
        search?.bookingId ||
        search?.createdDateStart ||
        search?.createdDateEnd ||
        search?.travelStartDate ||
        search?.travelEndDate ||
        search?.companyName ||
        search?.userName ||
        search?.passengerName ||
        search?.passengerNumber ||
        search?.paymentStatus ||
        search?.bookingStatus ||
        search?.driverName ||
        search?.driverNumber ||
        search?.invoiceNumber ||
        search?.invoicedStatus ||
        search?.affiliateName ||
        search?.groupId
      ) {
        dispatch({
          // type: "GET_ALL_BOOKINGS",
          // payload: { token: token, search: search },
          type: "GET_ALL_BOOKINGS_WITH_SEARCH",
          payload: {
            token: token,
            search: search,
            pageCount: pageCount?.toString(),
            userName: user?.userName?.toString(),
            viewBookingPermisision:
              user?.permission?.manageBooking?.viewBooking?.permission?.toString(),
            companyId: user?.company?._id?.toString(),
            userRole: user?.role?.toString(),
          },
        });
      } else {
        dispatch({
          type: "GET_ALL_BOOKINGS",
          payload: {
            // token: token,
            pageCount: pageCount?.toString(),
            userName: user?.userName?.toString(),
            viewBookingPermisision:
              user?.permission?.manageBooking?.viewBooking?.permission?.toString(),
            companyId: user?.company?._id?.toString(),
            userRole: user?.role?.toString(),
          },
        });
      }
    }
  }, [pageCount, dispatch, token, user]);

  useEffect(() => {
    // dispatch({
    //   type: "TOTAL_BOOKING_COUNT",
    //   payload: { token: token },
    // });
    dispatch({
      type: "GET_ALL_ACTIVE_AFFILIATES",
      payload: { token },
    });
  }, [dispatch, token]);

  // const searchHandler = () => {
  //   dispatch({
  //     type: "GET_ALL_BOOKINGS",
  //     payload: { token: token, search: search },
  //   });
  //   setdrawerOpen(false);
  // };

  const searchHandler = (e) => {
    e.preventDefault();
    dispatch({
      type: "GET_ALL_BOOKINGS_WITH_SEARCH",
      payload: {
        token: token,
        search: search,
        pageCount: pageCount?.toString(),
        userName: user?.userName?.toString(),
        viewBookingPermisision:
          user?.permission?.manageBooking?.viewBooking?.permission?.toString(),
        companyId: user?.company?._id?.toString(),
        userRole: user?.role?.toString(),
      },
    });
    setIsSearch(true);
    setdrawerOpen(false);
  };

  // const handleClear = () => {
  //   dispatch(
  //     setSearch({
  //       ...search,
  //       bookingId: "",
  //       createdDateStart: "",
  //       createdDateEnd: "",
  //       travelStartDate: "",
  //       travelEndDate: "",
  //       companyName: "",
  //       passengerName: "",
  //       bookingStatus: "",
  //       paymentStatus: "",
  //     })
  //   );

  //   dispatch({ type: "GET_ALL_BOOKINGS", payload: { token: token } });
  // };
  const handleClear = () => {
    dispatch(
      setSearch({
        ...search,
        bookingId: "",
        createdDateStart: "",
        createdDateEnd: "",
        travelStartDate: "",
        travelEndDate: "",
        companyName: "",
        passengerName: "",
        bookingStatus: "",
        paymentStatus: "",
        userName: "",
        affiliateName: "",
        affiliateNumber: "",
        invoiceNumber: "",
        invoicedStatus: "",
        passengerNumber: "",
        driverName: "",
        driverNumber: "",
        groupId: "",
        quoteby: "",
      })
    );
    setdateType("BOOKING_DATE");
    setIsSearch(false);
    dispatch(getAllSearchedbookings({ allSearchedBookings: [] }));
    dispatch(setSearchedBookingCount({ searchedBookingCount: "" }));
    dispatch(setPageCount({ pageCount: 1 }));

    dispatch({
      type: "GET_ALL_BOOKINGS",
      payload: {
        // token: token,
        pageCount: 1,
        userName: user?.userName?.toString(),
        viewBookingPermisision:
          user?.permission?.manageBooking?.viewBooking?.permission?.toString(),
        companyId: user?.company?._id?.toString(),
        userRole: user?.role?.toString(),
      },
    });
  };

  const datas = [];

  const nonAdminDatas = [];

  allBookings?.forEach((element) => {
    datas.push({
      bookingId: element?.bookingId,
      invoiceNo: element?.invoice_code_num, // admin
      createdDate: moment(element?.createdAt).format("DD-MM-YYYY"),
      Bookingtype: element?.bookingType,
      Bookedfor: element?.bookingFor,
      travelDate: moment(element?.travelDate).format("DD-MM-YYYY"),
      travelTime: element?.travelTime,
      passengerName:
        element?.passengerDetails?.firstName +
        " " +
        element?.passengerDetails?.lastName,
      pickupLocation: element?.source?.placename
        ?.toString()
        .replaceAll(",", " "),
      dropofLocation: element?.destination?.placename
        ?.toString()
        .replaceAll(",", " "),
      bookingStatus: element?.bookingStatus,
      bookingFee:
        element?.priceDetails?.currency + " " + element?.priceDetails?.amount,
      affiliateName: element?.affiliateDetails?.affiliateName, // admin
      affiliatePrice: element?.purchaseCurrency + " " + element?.purchasePrice, // admin
      driverName: element?.driverDetails?.name,

      driverContact:
        element?.driverDetails?.countryCode +
        " " +
        element?.driverDetails?.contactNumber,
      boookedBy: element?.userName,

      referenceNumber: element?.passengerDetails?.referenceNumber,
    });

    nonAdminDatas.push({
      bookingId: element?.bookingId,
      createdDate: moment(element?.createdAt).format("DD-MM-YYYY"),
      Bookingtype: element?.bookingType,
      Bookedfor: element?.bookingFor,
      travelDate: moment(element?.travelDate).format("DD-MM-YYYY"),
      travelTime: element?.travelTime,
      passengerName:
        element?.passengerDetails?.firstName +
        " " +
        element?.passengerDetails?.lastName,
      pickupLocation: element?.source?.placename
        ?.toString()
        .replaceAll(",", " "),
      dropofLocation: element?.destination?.placename
        ?.toString()
        .replaceAll(",", " "),
      bookingStatus: element?.bookingStatus,
      bookingFee:
        element?.priceDetails?.currency + " " + element?.priceDetails?.amount,
      driverName: element?.driverDetails?.name,
      driverContact:
        element?.driverDetails?.countryCode +
        " " +
        element?.driverDetails?.contactNumber,
      boookedBy: element?.userName,
      referenceNumber: element?.passengerDetails?.referenceNumber,
    });
  });

  const [calenderViewDate, setcalenderViewDate] = useState(
    moment().format("yyyy-MM-DD")
  );

  function tConvert(time) {
    // Check correct time format and split into components
    time = time
      .toString()
      .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

    if (time.length > 1) {
      // If time format correct
      time = time.slice(1); // Remove full string match value
      time[5] = +time[0] < 12 ? " AM" : " PM"; // Set AM/PM
      time[0] = +time[0] % 12 || 12; // Adjust hours
    }
    return time.join(""); // return adjusted time or original string
  }

  let calenderBookingData = [];
  allBookings.forEach((b) => calenderBookingData.push(b));

  calenderBookingData.sort((a, b) => a.travelTime - b.travelTime);

  useEffect(() => {
    if (localStorage.getItem("newbookingreload")) {
      localStorage.removeItem("newbookingreload");
    }
  }, []);

  console.log(groupBooking, "groupBooking");

  // sorint jobs for todat bookngs

  return (
    <div className="h-screen w-screen fixed">
      <Header token={token} />
      <div className="flex">
        <SideBar />
        <div className="w-screen h-screen">
          <div className="xl:flex items-center justify-between space-x-1 lg:px-2 xl:px-2 2xl:px-5 py-2 mb-2 border-b border-[#f1f1f1]">
            <Drawer
              anchor="top"
              open={drawerOpen}
              onClose={() => setdrawerOpen(false)}
              className=""
            >
              {/********************* FROM SCREEN LG *****************************/}
              <div className="hidden lg:block h-64 lg:h-auto xl:h-72 px-5 py-5">
                <div className="flex justify-between">
                  <div className="text-lg text-primary font-semibold">
                    Filter Bookings
                  </div>
                  <FontAwesomeIcon
                    icon={faClose}
                    className="text-primary text-xl cursor-pointer"
                    onClick={() => {
                      setdrawerOpen(false);
                    }}
                  />
                </div>
                <div className="lg:flex lg:space-x-5 xl:space-x-32 2xl:space-x-32">
                  <div className="py-3 flex flex-col space-x-16">
                    <div className="w-40 lg:w-40 xl:w-52 space-y-5">
                      <div className="">
                        <div className="flex lg:justify-start xl:justify-center text-sm">
                          <select
                            defaultValue={dateType}
                            id="date"
                            className="block w-full py-1.5 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border-b border-solid border-gray-400 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-red-600 focus:outline-none my-3 font-body"
                            name="dateType"
                            onChange={(e) => {
                              setdateType(e.target.value);
                              dispatch(
                                setSearch({
                                  ...search,
                                  createdDateStart: null,
                                  createdDateEnd: null,
                                  travelStartDate: null,
                                  travelEndDate: null,
                                })
                              );
                            }}
                          >
                            <option
                              value="BOOKING_DATE"
                              className="py-4 my-3 h-4 font-body"
                            >
                              Booking Date
                            </option>
                            <option value="TRAVEL_DATE">Travel Date</option>
                          </select>
                        </div>
                        {dateType === "BOOKING_DATE" && (
                          <div className="xl:flex xl:space-x-4 mt-4 space-y-4 xl:space-y-0">
                            <SearchItem
                              label="Start Date"
                              inputType="date"
                              name="createdDateStart"
                              value={search.createdDateStart}
                              onChange={(e) => {
                                dispatch(
                                  setSearch({
                                    ...search,
                                    createdDateStart: e.target.value,
                                  })
                                );
                              }}
                            />
                            <SearchItem
                              label="End Date"
                              inputType="date"
                              name="createdDateEnd"
                              onChange={(e) => {
                                dispatch(
                                  setSearch({
                                    ...search,
                                    createdDateEnd: e.target.value,
                                  })
                                );
                              }}
                              value={search.createdDateEnd}
                            />
                          </div>
                        )}
                        {dateType === "TRAVEL_DATE" && (
                          <div className="xl:flex xl:space-x-4 mt-4 space-y-4 xl:space-y-0">
                            <SearchItem
                              label="Start Date"
                              inputType="date"
                              name="travelStartDate"
                              value={search.travelStartDate}
                              onChange={(e) => {
                                dispatch(
                                  setSearch({
                                    ...search,
                                    travelStartDate: e.target.value,
                                  })
                                );
                              }}
                            />
                            <SearchItem
                              label="End Date"
                              inputType="date"
                              name="travelEndDate"
                              onChange={(e) => {
                                dispatch(
                                  setSearch({
                                    ...search,
                                    travelEndDate: e.target.value,
                                  })
                                );
                              }}
                              value={search.travelEndDate}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="mt-3 lg:mt-5">
                    <div className="grid lg:grid-cols-4 xl:grid-cols-5 2xl:grid-cols-7 3xl:grid-cols-9 gap-5">
                      <SearchItem
                        label={`Booking ID`}
                        inputType="text"
                        name="bookingId"
                        onChange={(e) => {
                          dispatch(
                            setSearch({
                              ...search,
                              bookingId: e.target.value,
                            })
                          );
                        }}
                        value={search.bookingId}
                      />
                      {user.role === "ADMIN" && (
                        <SearchItem
                          label={`Group ID`}
                          inputType="text"
                          name="groupId"
                          onChange={(e) => {
                            dispatch(
                              setSearch({
                                ...search,
                                groupId: e.target.value,
                              })
                            );
                          }}
                          value={search.groupId}
                        />
                      )}
                      {/* <SearchItem
                          label={`Invoice No.`}
                          inputType="text"
                          name="InvoiceNo"
                          onChange={(e) => {
                            dispatch(
                              setSearch({
                                ...search,
                                invoiceNo: e.target.value,
                              })
                            );
                          }}
                          value={search.invoiceNo}
                        /> */}

                      <SearchItem
                        label={`Company Name`}
                        inputType="text"
                        name="companyName"
                        onChange={(e) => {
                          dispatch(
                            setSearch({
                              ...search,
                              companyName: e.target.value,
                            })
                          );
                        }}
                        value={search.companyName}
                      />
                      <SearchItem
                        label={`User Name`}
                        inputType="text"
                        name="userName"
                        onChange={(e) => {
                          dispatch(
                            setSearch({ ...search, userName: e.target.value })
                          );
                        }}
                        value={search.userName}
                      />

                      {user.role === "ADMIN" && (
                        <>
                          <SearchItem
                            label={`Invoice Number`}
                            inputType="text"
                            name="invoiceNumber"
                            onChange={(e) => {
                              dispatch(
                                setSearch({
                                  ...search,
                                  invoiceNumber: e.target.value,
                                })
                              );
                            }}
                            value={search.invoiceNumber}
                          />

                          <SearchItem
                            label={`Affiliate Name`}
                            inputType="text"
                            name="affiliateName"
                            onChange={(e) => {
                              dispatch(
                                setSearch({
                                  ...search,
                                  affiliateName: e.target.value,
                                })
                              );
                            }}
                            value={search.affiliateName}
                          />
                        </>
                      )}

                      <SearchItem
                        label={`Passenger Name`}
                        inputType="text"
                        name="passengerName"
                        onChange={(e) => {
                          dispatch(
                            setSearch({
                              ...search,
                              passengerName: e.target.value,
                            })
                          );
                        }}
                        // value={search.bookingId}
                      />
                      <SearchItem
                        label={`Passenger Number`}
                        inputType="text"
                        name="passengerNumber"
                        onChange={(e) => {
                          dispatch(
                            setSearch({
                              ...search,
                              passengerNumber: e.target.value,
                            })
                          );
                        }}
                        // value={search.customerNumber}
                      />
                      <SearchItem
                        label={`Driver Name`}
                        inputType="text"
                        name="driverName"
                        onChange={(e) => {
                          dispatch(
                            setSearch({
                              ...search,
                              driverName: e.target.value,
                            })
                          );
                        }}
                        // value={search.customerNumber}
                      />
                      <SearchItem
                        label={`Driver Number`}
                        inputType="text"
                        name="driverNumber"
                        onChange={(e) => {
                          dispatch(
                            setSearch({
                              ...search,
                              driverNumber: e.target.value,
                            })
                          );
                        }}
                      />
                      <SearchItem
                        label={`Quote By`}
                        inputType="text"
                        name="quoteby"
                        onChange={(e) => {
                          dispatch(
                            setSearch({
                              ...search,
                              quoteby: e.target.value,
                            })
                          );
                        }}
                      />
                    </div>
                    <div className="xs:flex xs:space-x-10 lg:space-x-4 items-center mt-4">
                      <div className="w-36 text-sm text-gray-600">
                        <div>Booking Status</div>
                        <div className="flex justify-center text-sm  ">
                          <select
                            defaultValue={search?.bookingStatus}
                            id="date"
                            className="block w-full text-sm font-normal text-gray-600 bg-white bg-clip-padding bg-no-repeat border-b border-solid border-gray-400 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-red-600 focus:outline-none my-3"
                            name="dateType"
                            onChange={(e) => {
                              dispatch(
                                setSearch({
                                  ...search,
                                  bookingStatus: e.target.value,
                                })
                              );
                            }}
                          >
                            <option value="NONE" className="py-4 my-3 h-4">
                              Select
                            </option>
                            <option value="COMPLETED">Completed</option>
                            <option value="CONFIRMED">Confirmed</option>
                            <option value="CANCELLED">Cancelled</option>
                          </select>
                        </div>
                      </div>
                      {user.role === "ADMIN" && (
                        <>
                          <div className="w-36 text-sm text-gray-600">
                            <div>Payment Status</div>
                            <div className="flex justify-center text-sm">
                              <select
                                defaultValue={search?.paymentStatus}
                                id="date"
                                className="block w-full text-sm font-normal text-gray-600 bg-white bg-clip-padding bg-no-repeat border-b border-solid border-gray-400 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-red-600 focus:outline-none my-3"
                                name="dateType"
                                onChange={(e) => {
                                  dispatch(
                                    setSearch({
                                      ...search,
                                      paymentStatus: e.target.value,
                                    })
                                  );
                                }}
                              >
                                <option value="NONE" className="py-4 my-3 h-4">
                                  Select
                                </option>
                                <option value="PAID">Paid</option>
                                <option value="UNPAID">Unpaid</option>
                              </select>
                            </div>
                          </div>
                        </>
                      )}
                      {user.role === "ADMIN" && (
                        <>
                          <div className="w-36 text-sm text-gray-600">
                            <h2>Invoice Status</h2>
                            <div className="flex justify-center text-sm  ">
                              <select
                                defaultValue={search?.invoicedStatus}
                                id="date"
                                className="block w-full text-sm font-normal text-gray-600 bg-white bg-clip-padding bg-no-repeat border-b border-solid border-gray-400 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-red-600 focus:outline-none my-3"
                                name="dateType"
                                onChange={(e) => {
                                  dispatch(
                                    setSearch({
                                      ...search,
                                      invoicedStatus: e.target.value,
                                    })
                                  );
                                }}
                              >
                                <option value="NONE" className="py-4 my-3 h-4">
                                  Select
                                </option>
                                <option value="INVOICED">Invoiced</option>
                                <option value="NON-INVOICED">
                                  Non Invoiced
                                </option>
                              </select>
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
                <div className="flex  justify-end space-x-3 pb-5">
                  <button
                    className="bg-red-600 text-white px-4 py-1 rounded-md"
                    onClick={searchHandler}
                  >
                    Search
                  </button>
                  <button
                    className="border-red-600 text-primary border px-4 py-1 rounded-md"
                    onClick={() => {
                      setdrawerOpen(false);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>

              {/********************* SCREEN UPTO LG *****************************/}
              <div className="lg:hidden h-96 sm:h-96 lg:h-auto xl:h-64 px-2 sm:px-5 py-5">
                <div className="flex justify-between px-2">
                  <div className="text-lg text-primary font-semibold pl-2 xs:pl-0">
                    Filter Bookings
                  </div>
                  <FontAwesomeIcon
                    icon={faClose}
                    className="text-primary text-xl cursor-pointer"
                    onClick={() => {
                      setdrawerOpen(false);
                    }}
                  />
                </div>
                <div className="lg:flex lg:space-x-5 xl:space-x-32 2xl:space-x-32">
                  <div className="py-3 flex flex-col space-x-16">
                    <div className="w-40 lg:w-40 xl:w-52 space-y-5">
                      <div className="xs:flex xs:items-center space-x-4 sm:space-x-6">
                        <div className="flex lg:justify-start xl:justify-center text-sm ml-4 xs:ml-2">
                          <select
                            id="date"
                            className="block w-36 sm:w-auto px-1 sm:px-3 py-1.5 text-sm sm:text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border-b border-solid border-gray-400 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-red-600 focus:outline-none my-3 font-body"
                            name="dateType"
                            onChange={(e) => {
                              setdateType(e.target.value);
                              dispatch(
                                setSearch({
                                  ...search,
                                  createdDateStart: null,
                                  createdDateEnd: null,
                                  travelStartDate: null,
                                  travelEndDate: null,
                                })
                              );
                            }}
                          >
                            <option
                              value="BOOKING_DATE"
                              className="py-4 my-3 h-4 font-body"
                            >
                              Booking Date
                            </option>
                            <option value="TRAVEL_DATE">Travel Date</option>
                          </select>
                        </div>
                        {dateType === "BOOKING_DATE" && (
                          <div className="flex space-x-4 sm:space-x-6 lg:mt-4 xs:mt-0">
                            <SearchItem
                              label="Start Date"
                              inputType="date"
                              name="createdDateStart"
                              value={search.createdDateStart}
                              onChange={(e) => {
                                dispatch(
                                  setSearch({
                                    ...search,
                                    createdDateStart: e.target.value,
                                  })
                                );
                              }}
                            />
                            <SearchItem
                              label="End Date"
                              inputType="date"
                              name="createdDateEnd"
                              onChange={(e) => {
                                dispatch(
                                  setSearch({
                                    ...search,
                                    createdDateEnd: e.target.value,
                                  })
                                );
                              }}
                              value={search.createdDateEnd}
                            />
                          </div>
                        )}
                        {dateType === "TRAVEL_DATE" && (
                          <div className="flex lg:mt-4 space-x-4 sm:space-x-6">
                            <SearchItem
                              label="Start Date"
                              inputType="date"
                              name="travelStartDate"
                              value={search.travelStartDate}
                              onChange={(e) => {
                                dispatch(
                                  setSearch({
                                    ...search,
                                    travelStartDate: e.target.value,
                                  })
                                );
                              }}
                            />
                            <SearchItem
                              label="End Date"
                              inputType="date"
                              name="travelEndDate"
                              onChange={(e) => {
                                dispatch(
                                  setSearch({
                                    ...search,
                                    travelEndDate: e.target.value,
                                  })
                                );
                              }}
                              value={search.travelEndDate}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="mt-3 lg:mt-5">
                    <div className="grid grid-cols-2 xs:grid-cols-3 md:grid-cols-3 2md:grid-cols-5 lg:grid-cols-4 gap-5 md:gap-x-4 justify-items-start px-4 xs:px-2">
                      <SearchItem
                        label={`Booking ID`}
                        inputType="text"
                        name="bookingId"
                        onChange={(e) => {
                          dispatch(
                            setSearch({
                              ...search,
                              bookingId: e.target.value,
                            })
                          );
                        }}
                        value={search.bookingId}
                      />
                      {user.role === "ADMIN" && (
                        <SearchItem
                          label={`Group ID`}
                          inputType="text"
                          name="groupId"
                          onChange={(e) => {
                            dispatch(
                              setSearch({
                                ...search,
                                groupId: e.target.value,
                              })
                            );
                          }}
                          value={search.groupId}
                        />
                      )}
                      <SearchItem
                        label={`Company Name`}
                        inputType="text"
                        name="companyName"
                        onChange={(e) => {
                          dispatch(
                            setSearch({
                              ...search,
                              companyName: e.target.value,
                            })
                          );
                        }}
                        value={search.companyName}
                      />

                      <SearchItem
                        label={`User Name`}
                        inputType="text"
                        name="userName"
                        onChange={(e) => {
                          dispatch(
                            setSearch({ ...search, userName: e.target.value })
                          );
                        }}
                        value={search.userName}
                      />
                      {user.role === "ADMIN" && (
                        <>
                          <SearchItem
                            label={`Invoice Number`}
                            inputType="text"
                            name="invoiceNumber"
                            onChange={(e) => {
                              dispatch(
                                setSearch({
                                  ...search,
                                  invoiceNumber: e.target.value,
                                })
                              );
                            }}
                            value={search.invoiceNumber}
                          />
                        </>
                      )}
                      <SearchItem
                        label={`Affiliate Name`}
                        inputType="text"
                        name="affiliateName"
                        onChange={(e) => {
                          dispatch(
                            setSearch({
                              ...search,
                              affiliateName: e.target.value,
                            })
                          );
                        }}
                        value={search.affiliateName}
                      />

                      {/* <div className="ml-4"> */}
                      <SearchItem
                        label={`Passenger Name`}
                        inputType="text"
                        name="passengerName"
                        onChange={(e) => {
                          dispatch(
                            setSearch({
                              ...search,
                              passengerName: e.target.value,
                            })
                          );
                        }}
                        // value={search.passengerName}
                      />
                      <SearchItem
                        label={`Passenger Number`}
                        inputType="text"
                        name="passengerNumber"
                        onChange={(e) => {
                          dispatch(
                            setSearch({
                              ...search,
                              passengerNumber: e.target.value,
                            })
                          );
                        }}
                        // value={search.passengerNumber}
                      />
                      <SearchItem
                        label={`Driver Name`}
                        inputType="text"
                        name="driverName"
                        onChange={(e) => {
                          dispatch(
                            setSearch({
                              ...search,
                              driverName: e.target.value,
                            })
                          );
                        }}
                        // value={search.customerNumber}
                      />
                      <SearchItem
                        label={`Driver Number`}
                        inputType="text"
                        name="driverNumber"
                        onChange={(e) => {
                          dispatch(
                            setSearch({
                              ...search,
                              driverNumber: e.target.value,
                            })
                          );
                        }}
                        // value={search.customerNumber}
                      />
                      {/* </div> */}
                    </div>
                    <div className="xs:flex xs:space-x-10 items-center mt-5 px-4 xs:px-2">
                      <div className="w-36 text-sm text-gray-600">
                        <h2>Booking Status</h2>
                        <div className="flex justify-center text-sm  ">
                          <select
                            defaultValue={search?.bookingStatus}
                            id="date"
                            className="block w-full text-sm font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border-b border-solid border-gray-400 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-red-600 focus:outline-none my-3"
                            name="dateType"
                            onChange={(e) => {
                              dispatch(
                                setSearch({
                                  ...search,
                                  bookingStatus: e.target.value,
                                })
                              );
                            }}
                          >
                            <option value="NONE" className="py-4 my-3 h-4">
                              Select
                            </option>
                            <option value="COMPLETED">Completed</option>
                            <option value="CONFIRMED">Confirmed</option>
                            <option value="CANCELLED">Cancelled</option>
                            <option value="POB">Pob</option>
                          </select>
                        </div>
                      </div>
                      <div className="w-36 text-sm text-gray-600">
                        <h2>Payment Status</h2>
                        <div className="flex justify-center text-sm  ">
                          <select
                            defaultValue={search?.paymentStatus}
                            id="date"
                            className="block w-full text-sm font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border-b border-solid border-gray-400 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-red-600 focus:outline-none my-3"
                            name="dateType"
                            onChange={(e) => {
                              dispatch(
                                setSearch({
                                  ...search,
                                  paymentStatus: e.target.value,
                                })
                              );
                            }}
                          >
                            <option value="NONE" className="py-4 my-3 h-4">
                              Select
                            </option>
                            <option value="PAID">Paid</option>
                            <option value="UNPAID">Unpaid</option>
                          </select>
                        </div>
                      </div>
                      <div className="w-36 text-sm text-gray-600">
                        <h2>Invoice Status</h2>
                        <div className="flex justify-center text-sm  ">
                          <select
                            defaultValue={search?.paymentStatus}
                            id="date"
                            className="block w-full text-sm font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border-b border-solid border-gray-400 transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-red-600 focus:outline-none my-3"
                            name="dateType"
                            onChange={(e) => {
                              dispatch(
                                setSearch({
                                  ...search,
                                  paymentStatus: e.target.value,
                                })
                              );
                            }}
                          >
                            <option value="NONE" className="py-4 my-3 h-4">
                              Select
                            </option>
                            <option value="INVOICED">Invoiced</option>
                            <option value="NON-INVOICED">Non Invoiced</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="flex justify-end space-x-3 pb-5 mt-2">
                  <button
                    className="bg-red-600 text-white px-4 py-1 rounded-md"
                    onClick={searchHandler}
                  >
                    Search
                  </button>
                  <button
                    className="border-red-600 text-primary border px-4 py-1 rounded-md"
                    onClick={() => {
                      setdrawerOpen(false);
                    }}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </Drawer>
            <div className="hidden xl:block">
              {!isBulkAssign && user?.role === "ADMIN" && (
                <div
                  onClick={() => {
                    setisBulkAssign(true);
                  }}
                  className="lg:w-32 xl:w-auto px-4 2xl:px-3 py-4 2xl:py-3 text-center rounded-md text-white hover:bg-red-400 cursor-pointer text-sm bg-[#fb4156] items-center"
                >
                  <div className="flex space-x-2 items-center">
                    <FontAwesomeIcon icon={faPlus} />
                    <h2 className="font-medium hidden 2xl:block">
                      Bulk Assign
                    </h2>
                  </div>
                </div>
              )}
              {isBulkAssign && (
                <>
                  <div className="flex space-x-2 text-[14px] items-center justify-between">
                    <div>Select Affiliate</div>
                    <div className="flex">
                      <IconButton
                        size="10"
                        onClick={() => {
                          setisBulkAssign(false);
                          setaffiliatedetailsAssigned([]);
                        }}
                      >
                        <Close />
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          affiliatedetailsAssigned.forEach((affiliate) => {
                            dispatch({
                              type: "UPDATE_BOOKING",
                              payload: {
                                body: affiliate,
                                token,
                                msg: "Affiliate Assigned Successfully",
                              },
                            });
                            // assignedAffiliateSendVoucher.forEach((voucher) => {
                            //   if (voucher.booking_id === affiliate.bookingId) {
                            //     const body = {
                            //       affiliate_name: affiliateName,
                            //       email: voucher.email,
                            //       booking_id: voucher.booking_id,
                            //       from: voucher.from,
                            //       to: voucher.to,
                            //       timeAndDate: voucher.timeAndDate,

                            //       bookingType: voucher.bookingType,

                            //       bookingStatus: voucher.bookingStatus,
                            //       distance:
                            //         voucher?.bookingType === "Hourly"
                            //           ? `${voucher?.duration + " hours"}`
                            //           : Math.round(voucher?.travelDistance),
                            //       flt_no: voucher.flt_no,
                            //       Reference_No: voucher.Reference_No,
                            //       vehicleType: voucher.vehicleType,
                            //       price:
                            //         voucher.purchaseCurrency +
                            //         " " +
                            //         voucher.purchasePrice,
                            //       passengerName: voucher.passengerName,
                            //       pax_email: voucher.pax_email,
                            //       mob_number: voucher.mob_number,
                            //       pax: voucher.pax,
                            //       emergency_number: voucher.emergency_number,
                            //     };
                            //     dispatch({
                            //       type: "SEND_AFFILIATE_VOUCHER",
                            //       payload: {
                            //         token,
                            //         body: body,
                            //       },
                            //     });
                            //   }
                            // });
                          });
                          docketarr.forEach((docket) => {
                            dispatch({
                              type: "CREATE_DOCKET",
                              payload: docket,
                            });
                          });
                          setisBulkAssign(false);
                          setaffiliatedetailsAssigned([]);
                        }}
                      >
                        <Save />
                      </IconButton>
                    </div>
                  </div>
                  <div className="pt-2">
                    <Select
                      // defaultValue={{
                      //     value: affiliateDetails,
                      //     label: affiliateDetails?.affiliateName,
                      //   }}
                      onChange={(e) => {
                        setassignAffiliateDetail({
                          ...assignAffiliateDetail,
                          affiliateContact: e?.value?.contact,
                          affiliateId: e?.value?.id,
                        });
                        setassignAffiliateMail(e?.value?.email);
                        setaffiliateName(e?.value?.affiliateName);
                      }}
                      options={activeAffiliates.map((affiliate) => {
                        return {
                          value: {
                            id: affiliate._id,
                            contact: affiliate.phone1,
                            email: affiliate.email1,
                            affiliateName: affiliate.affiliateName,
                          },
                          label: affiliate?.affiliateName,
                        };
                      })}
                    />
                    <div className="text-xs">
                      Total selected bookings:{" "}
                      <span className="text-base">
                        {affiliatedetailsAssigned.length}
                      </span>
                    </div>
                  </div>
                </>
              )}
            </div>
            {/* SCREEN 2MD-980PX TO LARGER */}
            <div className="bg-[#f5f5f5] h-12 rounded-xl flex items-center sm:space-x-12 md:space-x-3 lg:space-x-8 xl:space-x-5 p-1">
              {/* All */}
              <div
                onClick={() => {
                  dispatch(
                    setJobsTab({
                      ...jobsTab,
                      jobsToday: false,
                      allBookings: true,
                      jobsTomorrow: false,
                      unassignedJobs: false,
                      inprogressJobs: false,
                      paymentPending: false,
                    })
                  );
                }}
                className={`sm:flex md:flex-col 2md:flex-row items-center justify-center text-center w-full xl:w-40 2xl:w-48 h-10 cursor-pointer space-x-1 ${
                  jobsTab.allBookings
                    ? "bg-white rounded-lg shadow border border-gray-100 w-full 2xl:w-48 h-10 text-secondary"
                    : "text-zinc-500"
                }   `}
              >
                <div className="text-xs sm:text-sm md:text-xs 2md:text-sm font-medium font-body">
                  {`${
                    allSearchedBookings?.length > 0 ? "Searched" : "Bookings"
                  }`}
                </div>
                <div className="text-base 2md:text-sm font-semibold font-body">
                  {`${
                    allSearchedBookings?.length > 0
                      ? `${searchedBookingCount}/${totalBookingCount}`
                      : totalBookingCount
                  }`}
                </div>
              </div>

              {/* jobs for today */}
              {user?.role === "ADMIN" && (
                <div
                  onClick={() => {
                    dispatch(
                      setJobsTab({
                        ...jobsTab,
                        jobsToday: true,
                        allBookings: false,
                        jobsTomorrow: false,
                        unassignedJobs: false,
                        inprogressJobs: false,
                        paymentPending: false,
                      })
                    );
                  }}
                  className={`sm:flex md:flex-col 2md:flex-row items-center justify-center text-center w-full xl:w-40 2xl:w-48 h-10 cursor-pointer space-x-1 ${
                    jobsTab.jobsToday
                      ? "bg-white rounded-lg shadow border border-gray-100 w-full 2xl:w-48 h-10 text-secondary"
                      : "text-zinc-500"
                  }  `}
                >
                  <div className="text-xs sm:text-sm md:text-xs 2md:text-sm font-medium font-body">
                    Jobs For Today
                  </div>
                  <div className="text-base 2md:text-sm font-semibold font-body">
                    {/* {jobsForTodayBookings.length} */}
                    {totalTodayBookingsCount}
                  </div>
                </div>
              )}

              {/* jobs for tomorrow */}
              {user?.role === "ADMIN" && (
                <div
                  onClick={() => {
                    dispatch(
                      setJobsTab({
                        ...jobsTab,
                        jobsTomorrow: true,
                        allBookings: false,
                        jobsToday: false,
                        unassignedJobs: false,
                        inprogressJobs: false,
                        paymentPending: false,
                      })
                    );
                  }}
                  className={`sm:flex md:flex-col 2md:flex-row items-center justify-center text-center w-full xl:w-40 2xl:w-48 h-10 cursor-pointer space-x-1 ${
                    jobsTab.jobsTomorrow
                      ? " bg-white rounded-lg shadow border border-gray-100 w-full 2xl:w-48 h-10 text-secondary"
                      : "text-zinc-500"
                  }  `}
                >
                  <div className="text-xs sm:text-sm md:text-xs 2md:text-sm font-medium font-body">
                    Jobs For Tomorrow
                  </div>
                  <div className="text-base 2md:text-sm font-semibold font-body">
                    {/* {jobsForTomorrowBookings.length} */}
                    {totalTomorrowBookingsCount}
                  </div>
                </div>
              )}

              {/* unassigned jobs */}
              {user?.role === "ADMIN" && (
                <div
                  onClick={() => {
                    dispatch(
                      setJobsTab({
                        ...jobsTab,
                        jobsTomorrow: false,
                        allBookings: false,
                        jobsToday: false,
                        unassignedJobs: true,
                        inprogressJobs: false,
                        paymentPending: false,
                      })
                    );
                  }}
                  className={`sm:flex md:flex-col 2md:flex-row items-center justify-center text-center w-full xl:w-40 2xl:w-48 h-10 cursor-pointer space-x-1 ${
                    jobsTab.unassignedJobs
                      ? "bg-white rounded-lg shadow border border-gray-100 w-full 2xl:w-48 h-10 text-secondary"
                      : "text-zinc-500"
                  }  `}
                >
                  <div className="text-xs sm:text-sm md:text-xs 2md:text-sm font-medium font-body">
                    Unassigned Jobs
                  </div>
                  <div className="text-base 2md:text-sm font-semibold font-body">
                    {/* {unassignedJobs.length} */}
                    {totalunassignedBookingsCount}
                  </div>
                </div>
              )}
            </div>

            {/* SCREEN BELOW 2MD < 980PX */}

            {/* <div className="2md:hidden">
              <select
              defaultValue={bookingStatus}
              >
                <option
                  onChange={(e) => {
                    setBookingStatus(e.target.value);
                    dispatch(
                      setJobsTab({
                        ...jobsTab,
                        jobsToday: false,
                        allBookings: true,
                        jobsTomorrow: false,
                        unassignedJobs: false,
                      })
                    );
                  }}
                  value="ALL BOOKINGS"
                  className={`flex items-center justify-center w-full xl:w-40 2xl:w-48 h-10 cursor-pointer space-x-1 ${
                    jobsTab.allBookings
                      ? "bg-white rounded-lg shadow border border-gray-100 w-full 2xl:w-48 h-10 text-secondary"
                      : "text-zinc-500"
                  }   `}
                >
                  <div className="text-sm font-medium font-body">
                    {`${
                      allSearchedBookings?.length > 0
                        ? "Searched Bookings"
                        : "All Bookings"
                    }`}
                  </div>
                  <div className="text-base 2md:text-sm font-semibold font-body">
                    {`${
                      allSearchedBookings?.length > 0
                        ? `(${searchedBookingCount}/${totalBookingCount})`
                        : totalBookingCount
                    }`}
                  </div>
                </option>
                {user?.role === "ADMIN" && (
                  <option
                    onClick={() => {
                      dispatch(
                        setJobsTab({
                          ...jobsTab,
                          jobsToday: true,
                          allBookings: false,
                          jobsTomorrow: false,
                          unassignedJobs: false,
                        })
                      );
                    }}
                    className={`flex items-center justify-center w-full xl:w-40 2xl:w-48 h-10 cursor-pointer space-x-1 ${
                      jobsTab.jobsToday
                        ? "bg-white rounded-lg shadow border border-gray-100 w-full 2xl:w-48 h-10 text-secondary"
                        : "text-zinc-500"
                    }  `}
                  >
                    <div className="text-sm font-medium font-body">
                      Jobs For Today
                    </div>
                    <div className="text-base 2md:text-sm font-semibold font-body">
                      {jobsForTodayBookings.length}
                    </div>
                  </option>
                )}

                jobs for tomorrow
                {user?.role === "ADMIN" && (
                  <option
                    onClick={() => {
                      dispatch(
                        setJobsTab({
                          ...jobsTab,
                          jobsTomorrow: true,
                          allBookings: false,
                          jobsToday: false,
                          unassignedJobs: false,
                        })
                      );
                    }}
                    className={`flex items-center justify-center w-full xl:w-40 2xl:w-48 h-10 cursor-pointer space-x-1 ${
                      jobsTab.jobsTomorrow
                        ? " bg-white rounded-lg shadow border border-gray-100 w-full 2xl:w-48 h-10 text-secondary"
                        : "text-zinc-500"
                    }  `}
                  >
                    <div className="text-sm font-medium font-body">
                      Jobs For Tomorrow
                    </div>
                    <div className="text-base 2md:text-sm font-semibold font-body">
                      {jobsForTomorrowBookings.length}
                    </div>
                  </option>
                )}

                unassigned jobs
                {user?.role === "ADMIN" && (
                  <option
                    onClick={() => {
                      dispatch(
                        setJobsTab({
                          ...jobsTab,
                          jobsTomorrow: false,
                          allBookings: false,
                          jobsToday: false,
                          unassignedJobs: true,
                        })
                      );
                    }}
                    className={`flex items-center justify-center w-full xl:w-40 2xl:w-48 h-10 cursor-pointer space-x-1 ${
                      jobsTab.unassignedJobs
                        ? "bg-white rounded-lg shadow border border-gray-100 w-full 2xl:w-48 h-10 text-secondary"
                        : "text-zinc-500"
                    }  `}
                  >
                    <div className="text-sm font-medium font-body">
                      Unassigned Jobs
                    </div>
                    <div className="text-base 2md:text-sm font-semibold font-body">
                      {unassignedJobs.length}
                    </div>
                  </option>
                )}
              </select>
            </div> */}
            {/* ----------------lg VIEW------------- */}

            <div className="flex space-x-1.5 mt-2 xl:mt-0">
              <div className="mt-2.5 sm:mt-2 md:mt-2 xl:mt-2.5 xl:hidden">
                {!isBulkAssign && user?.role === "ADMIN" && (
                  <div
                    onClick={() => {
                      setisBulkAssign(true);
                    }}
                    className="xl:w-auto px-4 lg:px-3 2xl:px-3 py-3 sm:py-2.5 md:py-[13px] 2md:py-2.5 lg:py-3 2xl:py-3 text-center rounded-md text-white hover:bg-[#fb5467] cursor-pointer text-sm bg-[#fb4156] items-center"
                  >
                    <div className="flex space-x-2 items-center">
                      <FontAwesomeIcon icon={faPlus} />
                      <h2 className="font-medium hidden sm:block md:hidden 2md:block lg:hidden 2xl:block">
                        Bulk Assign
                      </h2>
                    </div>
                  </div>
                )}
                {isBulkAssign && (
                  <>
                    <div className="flex space-x-2 text-[14px] items-center justify-between">
                      <div>Select Affiliate</div>
                      <div className="flex">
                        <IconButton
                          size="10"
                          onClick={() => {
                            setisBulkAssign(false);
                            setaffiliatedetailsAssigned([]);
                          }}
                        >
                          <Close />
                        </IconButton>
                        <IconButton
                          onClick={() => {
                            affiliatedetailsAssigned.forEach((affiliate) => {
                              dispatch({
                                type: "UPDATE_BOOKING",
                                payload: {
                                  body: affiliate,
                                  token,
                                  msg: "Affiliate Assigned Successfully",
                                },
                              });
                              // assignedAffiliateSendVoucher.forEach((voucher) => {
                              //   if (voucher.booking_id === affiliate.bookingId) {
                              //     const body = {
                              //       affiliate_name: affiliateName,
                              //       email: voucher.email,
                              //       booking_id: voucher.booking_id,
                              //       from: voucher.from,
                              //       to: voucher.to,
                              //       timeAndDate: voucher.timeAndDate,

                              //       bookingType: voucher.bookingType,

                              //       bookingStatus: voucher.bookingStatus,
                              //       distance:
                              //         voucher?.bookingType === "Hourly"
                              //           ? `${voucher?.duration + " hours"}`
                              //           : Math.round(voucher?.travelDistance),
                              //       flt_no: voucher.flt_no,
                              //       Reference_No: voucher.Reference_No,
                              //       vehicleType: voucher.vehicleType,
                              //       price:
                              //         voucher.purchaseCurrency +
                              //         " " +
                              //         voucher.purchasePrice,
                              //       passengerName: voucher.passengerName,
                              //       pax_email: voucher.pax_email,
                              //       mob_number: voucher.mob_number,
                              //       pax: voucher.pax,
                              //       emergency_number: voucher.emergency_number,
                              //     };
                              //     dispatch({
                              //       type: "SEND_AFFILIATE_VOUCHER",
                              //       payload: {
                              //         token,
                              //         body: body,
                              //       },
                              //     });
                              //   }
                              // });
                            });
                            docketarr.forEach((docket) => {
                              dispatch({
                                type: "CREATE_DOCKET",
                                payload: docket,
                              });
                            });
                            setisBulkAssign(false);
                            setaffiliatedetailsAssigned([]);
                          }}
                        >
                          <Save />
                        </IconButton>
                      </div>
                    </div>
                    <div className="pt-2">
                      <Select
                        // defaultValue={{
                        //     value: affiliateDetails,
                        //     label: affiliateDetails?.affiliateName,
                        //   }}
                        onChange={(e) => {
                          setassignAffiliateDetail({
                            ...assignAffiliateDetail,
                            affiliateContact: e?.value?.contact,
                            affiliateId: e?.value?.id,
                          });
                          setassignAffiliateMail(e?.value?.email);
                          setaffiliateName(e?.value?.affiliateName);
                        }}
                        options={activeAffiliates.map((affiliate) => {
                          return {
                            value: {
                              id: affiliate._id,
                              contact: affiliate.phone1,
                              email: affiliate.email1,
                              affiliateName: affiliate.affiliateName,
                            },
                            label: affiliate?.affiliateName,
                          };
                        })}
                      />
                      <div className="text-xs">
                        Total selected bookings:{" "}
                        <span className="text-base">
                          {affiliatedetailsAssigned.length}
                        </span>
                      </div>
                    </div>
                  </>
                )}
              </div>
              <div className="flex items-center space-x-2 justify-start xl:justify-end xl:space-x-2 2xl:space-x-2 py-2 2xl:pr-3 w-64">
                {/* <div className="hidden lg:block"> */}
                <div className="">
                  <div className="space-x-5 xl:space-x-5 2xl:space-x-10 flex">
                    <div className="space-y-2">
                      <div className="group-hover:text-white">
                        {jobsTab.allBookings && (
                          <>
                            <Tooltip title="Reset">
                              <div
                                onClick={
                                  allSearchedBookings.length > 0 || isSearch
                                    ? handleClear
                                    : ""
                                }
                                className={`${
                                  allSearchedBookings.length > 0 || isSearch
                                    ? "bg-secondary text-white"
                                    : "bg-[#f5f5f5] text-primary"
                                } w-10 h-10 px-2.5 py-2 rounded-md hover:bg-secondary cursor-pointer group`}
                              >
                                <FontAwesomeIcon
                                  icon={faRotate}
                                  className="w-5 text-[#555555] group-hover:text-white group-active:text-white"
                                />
                              </div>
                            </Tooltip>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {jobsTab.allBookings && (
                  <>
                    <Tooltip title="Filter">
                      <div
                        onClick={() => {
                          setdrawerOpen(true);
                        }}
                        className=" bg-[#f5f5f5] w-10 h-10 px-2.5 py-2.5 rounded-md cursor-pointer hover:bg-secondary group"
                      >
                        <FilterIcon className="w-5 text-[#555555] group-hover:text-white" />
                      </div>
                    </Tooltip>
                    <Tooltip
                      title="Download Report"
                      onClick={downloadStart ? "" : downloadReportHandler}
                    >
                      <div className="bg-[#f5f5f5] w-10 h-10 px-2.5 py-2.5 rounded-md cursor-pointer hover:bg-secondary group">
                        {/* {user?.role === "ADMIN" ? (
                  <CsvDownloader
                    filename="Bookings"
                    extension=".csv"
                    separator=","
                    columns={columns}
                    datas={datas}
                    text="Download report"
                  >
                    <div
                      className="report_download"
                      onClick={downloadReportHandler}
                    >
                      <DownloadIcon className="w-5 report_download_icon" />
                    </div>
                  </CsvDownloader>
                ) : (
                  <CsvDownloader
                    filename="Bookings"
                    extension=".csv"
                    separator=","
                    columns={columnsNonAdmin}
                    datas={nonAdminDatas}
                    text="Download report"
                  >
                    <div
                      className="report_download"
                      onClick={downloadReportHandler}
                    >
                      <DownloadIcon className="w-5 report_download_icon  " />
                    </div>
                  </CsvDownloader>
                )} */}

                        <div className="report_download">
                          {downloadStart ? (
                            <>
                              {/* <Spinner className="text-[#fb4156]/50" /> */}
                              <LoadingSpinner className="border-black h-6 w-6" />
                            </>
                          ) : (
                            <>
                              <DownloadIcon className="w-5 text-[#555555] report_download_icon group-hover:text-white" />
                            </>
                          )}
                        </div>
                      </div>
                    </Tooltip>
                  </>
                )}

                <div className="flex items-center space-x-0 bg-[#f5f5f5] w-auto h-10 py-0.25 rounded-md font-semibold">
                  <div className="bg-[#fb4156] w-1 h-6 rounded-r-md"></div>
                  <div className="flex items-center space-x-1.5 px-3">
                    <span className="text-sm font-bold sm:text-base text-secondary font-inter">
                      {/* {paginatedBookingCount} */}
                      {/* {allBookings.length} */}
                      {jobsTab?.allBookings && paginatedBookingCount}
                      {jobsTab?.jobsToday && paginatedTodayBookingsCount}
                      {jobsTab?.jobsTomorrow && paginatedTomorrowBookingsCount}
                      {jobsTab?.unassignedJobs &&
                        paginatedunassignedBookingsCount}
                    </span>
                    <span className="bg-gray-400 w-[2px] h-5"></span>
                    <span className="text-sm font-medium sm:text-base text-black font-inter">
                      {jobsTab?.allBookings && (
                        <>
                          {`${
                            searchedBookingCount
                              ? searchedBookingCount
                              : totalBookingCount
                          }`}
                        </>
                      )}
                      {jobsTab?.jobsToday &&
                        (totalTodayBookingsCount ? totalTodayBookingsCount : 0)}
                      {jobsTab?.jobsTomorrow &&
                        (totalTomorrowBookingsCount
                          ? totalTomorrowBookingsCount
                          : 0)}
                      {jobsTab?.unassignedJobs &&
                        (totalunassignedBookingsCount
                          ? totalunassignedBookingsCount
                          : 0)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {!calenderView && (
            <div className="flex justify-between items-center mb-2.5">
              {user?.role === "ADMIN" && (
                <div className="flex justify-start px-5 space-x-3 items-center">
                  <Tooltip title="In Progress Jobs">
                    <button
                      onClick={() => {
                        dispatch(
                          setJobsTab({
                            ...jobsTab,
                            inprogressJobs: true,
                            allBookings: false,
                            jobsToday: false,
                            jobsTomorrow: false,
                            unassignedJobs: false,

                            paymentPending: false,
                          })
                        );
                      }}
                      className={`flex items-center space-x-2 border ${
                        jobsTab.inprogressJobs
                          ? "bg-teal-800 text-white"
                          : "bg-teal-600 text-white"
                      }  h-6 w-max px-3 text-sm  flex  rounded-2xl `}
                    >
                      <ClockIcon className="w-5" />
                      <span>{pobBookings.length} </span>

                      {pobBookings.length > 0 && (
                        <div class="relative px-1">
                          {/* <div class="w-16 h-16 bg-white rounded-lg shadow-2xl"></div> */}
                          <div class="absolute -top-0.5 right-0 -mr-1 -mt-1 w-3 h-3 rounded-full bg-gray-300 animate-ping"></div>
                          <div class="absolute -top-0.5 right-0 -mr-1 -mt-1 w-3 h-3 rounded-full bg-white"></div>
                        </div>
                      )}
                    </button>
                  </Tooltip>
                  <Tooltip title="Affiliate Pending Payments">
                    <span
                      className={`relative flex space-x-1 w-max px-4 items-center rounded-full ${
                        jobsTab?.paymentPending ? "bg-red-700" : "bg-red-600"
                      }  text-white cursor-pointer`}
                      onClick={() => {
                        dispatch(
                          setJobsTab({
                            ...jobsTab,
                            inprogressJobs: false,
                            allBookings: false,
                            jobsToday: false,
                            jobsTomorrow: false,
                            unassignedJobs: false,
                            paymentPending: true,
                          })
                        );
                      }}
                    >
                      <span className="text-sm">
                        <CreditCard
                          className={
                            affiliatePaymentPendingBookings?.length > 0 &&
                            "animate-flash"
                          }
                        />
                      </span>
                      <div className="font-semibold w-3 h">
                        {affiliatePaymentPendingBookings?.length}

                        {/* <div class=" px-1">

                        <div class="absolute top-2.5 right-2 -mr-1 -mt-1 w-3 h-3 rounded-full bg-red-200 animate-ping"></div>
                        <div class="absolute top-2.5 right-2 -mr-1 -mt-1 w-3 h-3 rounded-full bg-red-100"></div>
                      </div> */}
                      </div>
                    </span>
                  </Tooltip>

                  {user?.permission?.manageBooking?.finAmmendment
                    ?.permission === "ENABLE" && (
                    <>
                      <Tooltip title="Fin Amendment">
                        <Link to="/manageBooking/finAmendment">
                          <button className="flex items-center space-x-2 bg-yellow-600 h-6 w-max px-4 text-sm   text-white rounded-2xl">
                            <FontAwesomeIcon
                              icon={faNewspaper}
                              className="h-5"
                            />
                            <span className="font-semibold text-base">
                              {ammendmentFinanceCount}
                            </span>
                          </button>
                        </Link>
                      </Tooltip>
                    </>
                  )}

                  {user?.permission?.manageBooking?.opsAmmendment
                    ?.permission === "ENABLE" && (
                    <>
                      <Tooltip title="Ops Amendment">
                        <Link to="/manageBooking/opsAmendment">
                          <button className="flex items-center space-x-2 bg-orange-600 h-6 w-max px-4 text-sm   text-white rounded-2xl">
                            <FontAwesomeIcon
                              icon={faCircleExclamation}
                              className="h-4"
                            />
                            <span className="font-semibold text-base">
                              {ammendmentOpsCount}
                            </span>
                          </button>
                        </Link>
                      </Tooltip>
                    </>
                  )}
                </div>
              )}

              <div className="px-2 xl:px-5 py-1 2md:flex items-center space-x-2 md:space-x-10 justify-end xs:relative">
                {/* booking tabs */}

                {/* screen sm and greater */}
                <div className="flex space-x-3 items-end justify-between lg:justify-start lg:px-3 md:px-3 mt-2 xs:absolute xl:relative xs:right-2 2md:right-0 xs:bottom-10 xl:bottom-0 z-10 md:items-center xl:items-center">
                  <div className="flex items-center space-x-2">
                    {jobsTab.allBookings && user.role === "ADMIN" && (
                      <div className="hidden lg:block text-sm">Group: </div>
                    )}
                    {jobsTab.allBookings &&
                      user?.role === "ADMIN" &&
                      !isGroup && (
                        <Tooltip title="Create Group">
                          <button
                            onClick={() => {
                              setisGroup(true);
                            }}
                            className="hidden lg:flex items-center space-x-3  text-secondary px-2 py-1 rounded-full"
                          >
                            <Layers className="text-lg" />
                          </button>
                        </Tooltip>
                      )}

                    {jobsTab.allBookings &&
                      user?.role === "ADMIN" &&
                      !groupIn && (
                        <Tooltip title="Group In">
                          <button
                            onClick={() => {
                              setgroupIn(true);
                            }}
                            className="hidden lg:flex items-center space-x-3  text-secondary px-2 py-1 rounded-full"
                          >
                            <LibraryAdd className="text-lg" />
                          </button>
                        </Tooltip>
                      )}
                    {jobsTab.allBookings &&
                      user?.role === "ADMIN" &&
                      !groupOut && (
                        <Tooltip title="Group Out">
                          <button
                            onClick={() => {
                              setgroupOut(true);
                            }}
                            className="hidden lg:flex items-center space-x-3  text-secondary px-2 py-1 rounded-full"
                          >
                            <LayersClear className="text-lg" />
                          </button>
                        </Tooltip>
                      )}
                    {jobsTab.allBookings && user?.role === "ADMIN" && (
                      <Tooltip title="Invoice to group">
                        <button
                          onClick={() => {
                            setinvoiceGroup(true);
                          }}
                          className="hidden lg:flex items-center space-x-3  text-secondary px-2 py-1 rounded-full"
                        >
                          <Receipt className="text-lg" />
                        </button>
                      </Tooltip>
                    )}
                  </div>

                  {user.role === "ADMIN" && isGroup && (
                    <div className="flex space-x-2">
                      <button
                        onClick={() => {
                          dispatch({
                            type: "CREATE_GROUP_BOOKING",
                            payload: {
                              token: token,
                              body: { groupBooking },
                            },
                          });
                          setisGroup(false);
                          dispatch(setGroupBooking({}));
                        }}
                        className="hidden lg:flex items-center space-x-3 bg-teal-600 text-white px-2 py-1 rounded-full"
                      >
                        Create
                      </button>
                      <button
                        onClick={() => {
                          setisGroup(false);
                          dispatch(setGroupBooking({}));
                        }}
                        className="hidden lg:flex items-center space-x-3  px-2 py-1 rounded-full bg-secondary text-white"
                      >
                        Cancel
                      </button>
                    </div>
                  )}

                  {/* group in  */}

                  {user.role === "ADMIN" && groupIn && (
                    <div className="flex space-x-2">
                      <Select
                        onChange={(e) => {
                          setgroupId(e.value);
                        }}
                        options={groupIds.map((groupid) => {
                          return {
                            label: groupid?._id,
                            value: groupid?._id,
                          };
                        })}
                      />
                      <button
                        onClick={() => {
                          dispatch({
                            type: "GROUP_IN",
                            payload: {
                              token: token,
                              body: {
                                groupInBookings: groupBooking,
                              },
                              groupId: groupId,
                            },
                          });
                          setgroupIn(false);
                          dispatch(setGroupBooking({}));
                        }}
                        className="hidden lg:flex items-center space-x-3 bg-teal-600 text-white px-2 py-1 rounded-full"
                      >
                        Save
                      </button>
                      <button
                        onClick={() => {
                          setgroupIn(false);
                          dispatch(setGroupBooking({}));
                        }}
                        className="hidden lg:flex items-center space-x-3  px-2 py-1 rounded-full bg-secondary text-white"
                      >
                        Cancel
                      </button>
                    </div>
                  )}

                  {user.role === "ADMIN" && groupOut && (
                    <div className="flex space-x-2">
                      <button
                        onClick={() => {
                          dispatch({
                            type: "GROUP_OUT",
                            payload: {
                              token: token,
                              body: {
                                groupInBookings: groupBooking,
                              },
                            },
                          });
                          setgroupOut(false);
                          dispatch(setGroupBooking({}));
                        }}
                        className="hidden lg:flex items-center space-x-3 bg-teal-600 text-white px-2 py-1 rounded-full"
                      >
                        Save
                      </button>
                      <button
                        onClick={() => {
                          setgroupOut(false);
                          dispatch(setGroupBooking({}));
                        }}
                        className="hidden lg:flex items-center space-x-3  px-2 py-1 rounded-full bg-secondary text-white"
                      >
                        Cancel
                      </button>
                    </div>
                  )}

                  {user.role === "ADMIN" && invoiceGroup && (
                    <div className="flex space-x-2">
                      <Select
                        onChange={(e) => {
                          setgroupId(e.value);
                        }}
                        options={groupIds.map((groupid) => {
                          return {
                            label: groupid?._id,
                            value: groupid?._id,
                          };
                        })}
                      />
                      <div className="border-b-2">
                        <input
                          className="w-28 text-xs"
                          placeholder="Add Invoice number"
                          onChange={(e) => {
                            setinvoiceId(e.target.value);
                          }}
                        />
                      </div>

                      {groupId && (
                        <button
                          onClick={() => {
                            dispatch({
                              type: "ADD_INVOICE_TO_GROUPED_BOOKINGS",
                              payload: {
                                token: token,
                                body: {
                                  groupId: groupId,
                                  invoiceId: invoiceId,
                                },
                              },
                            });
                            setinvoiceGroup(false);
                            dispatch(setGroupBooking({}));
                          }}
                          className="hidden lg:flex items-center space-x-3 bg-teal-600 text-white px-2 py-1 rounded-full"
                        >
                          Save
                        </button>
                      )}
                      <button
                        onClick={() => {
                          setinvoiceGroup(false);
                          setgroupId("");
                          dispatch(setGroupBooking({}));
                        }}
                        className="hidden lg:flex items-center space-x-3  px-2 py-1 rounded-full bg-secondary text-white"
                      >
                        Cancel
                      </button>
                    </div>
                  )}

                  <div className="text-neutral-400 text-base font-medium font-inter whitespace-nowrap">
                    Page: {pageCount} -{" "}
                    {jobsTab?.allBookings && (
                      <>
                        {Math.ceil(
                          (searchedBookingCount
                            ? searchedBookingCount
                            : totalBookingCount) / 10
                        )}
                      </>
                    )}
                    {jobsTab?.jobsToday && (
                      <>{Math.ceil(totalTodayBookingsCount / 10)}</>
                    )}
                    {jobsTab?.jobsTomorrow && (
                      <>{Math.ceil(paginatedTomorrowBookingsCount / 10)}</>
                    )}
                    {jobsTab?.unassignedJobs && (
                      <>{Math.ceil(totalunassignedBookingsCount / 10)}</>
                    )}
                  </div>
                  <div
                    onClick={() => {
                      pageCount > 1 && dispatch(setPagePrev());
                    }}
                    className={`flex space-x-2 items-center justify-center text-xs w-5 h-5 shadow-md ${
                      pageCount > 1
                        ? "cursor-pointer bg-neutral-400 border border-stone-500 rounded-full text-white"
                        : "bg-white border border-neutral-300 rounded-full"
                    }  `}
                  >
                    <FontAwesomeIcon
                      icon={faChevronLeft}
                      className={`flex  space-x-2 items-center justify-center ${
                        pageCount > 1 ? "cursor-pointer" : "text-neutral-400"
                      }  `}
                    />
                    {/* <div className="font-body font-semibold">Prev</div> */}
                  </div>

                  <div
                    onClick={() => {
                      if (jobsTab.allBookings) {
                        pageCount <
                          Math.ceil(
                            (searchedBookingCount
                              ? searchedBookingCount
                              : totalBookingCount) / 10
                          ) && dispatch(setPageNext());
                      }

                      if (jobsTab.jobsToday) {
                        pageCount < Math.ceil(totalTodayBookingsCount / 10) &&
                          dispatch(setPageNext());
                      }

                      if (jobsTab.jobsTomorrow) {
                        pageCount <
                          Math.ceil(totalTomorrowBookingsCount / 10) &&
                          dispatch(setPageNext());
                      }

                      if (jobsTab.unassignedJobs) {
                        pageCount <
                          Math.ceil(totalunassignedBookingsCount / 10) &&
                          dispatch(setPageNext());
                      }
                    }}
                    className={`flex space-x-2 items-center justify-center text-xs w-5 h-5 shadow-md ${
                      pageCount < Math.ceil(totalBookingCount / 10)
                        ? "cursor-pointer bg-neutral-400 border border-stone-500 rounded-full text-white"
                        : "bg-white border border-neutral-300 rounded-full"
                    }  `}
                  >
                    {/* <div className="font-body font-semibold">Next</div> */}
                    <FontAwesomeIcon
                      icon={faChevronRight}
                      className={`flex space-x-2 items-center justify-center ${
                        pageCount < Math.ceil(totalBookingCount / 10)
                          ? "cursor-pointer"
                          : " text-neutral-400"
                      }  `}
                    />
                  </div>
                </div>
              </div>
            </div>
          )}
          {!bookingIsloading &&
            jobsTab.allBookings &&
            allBookings &&
            (allBookings.length === 0 ||
              (allSearchedBookings?.length === 0 &&
                searchedBookingCount === 0)) && (
              <div className="flex justify-center items-center h-[75vh]">
                <div className="text-2xl font-semibold font-body">
                  No Bookings Found
                </div>
              </div>
            )}

          {/* {!bookingIsloading &&
            jobsTab.allBookings &&
            allSearchedBookings?.length === 0 &&
            searchedBookingCount === 0 && (
              <div className="flex justify-center items-center h-[75vh]">
                <div className="text-2xl font-semibold font-body">
                  No Bookings Found
                </div>
              </div>
            )} */}

          {!calenderView ? (
            <div className="overflow-y-auto h-[75vh]   scrollbar">
              {!bookingIsloading ? (
                jobsTab.allBookings &&
                allSearchedBookings?.length > 0 &&
                searchedBookingCount > 0 ? (
                  <div key={allSearchedBookings?._id}>
                    {allSearchedBookings?.map((booking) => {
                      return (
                        <>
                          <ManageBookingItem
                            ObjectBookingId={booking?._id}
                            isBulkAssign={isBulkAssign}
                            isGroup={isGroup || groupIn || groupOut}
                            affiliateDetailsAssignedArr={
                              affiliatedetailsAssigned
                            }
                            extraPay={booking?.extraPay}
                            totalPayment={booking?.totalPayment}
                            extraHour={booking?.extraHour}
                            groupBookingMark={booking?.isGroupBooking}
                            groupId={booking?.groupId}
                            groupBookingObj={groupBooking}
                            affiliatePaymentStatus={booking?.affiliatePayment}
                            onClickedCheckbox={(e) => {
                              let groupBookingPayload;

                              if (
                                Object.keys(groupBooking).includes(
                                  booking?.bookingId
                                )
                              ) {
                                groupBookingPayload = {
                                  ...groupBooking,
                                };
                                delete groupBookingPayload[booking?.bookingId];

                                dispatch(setGroupBooking(groupBookingPayload));
                              } else {
                                groupBookingPayload = {
                                  ...groupBooking,
                                  [booking.bookingId]: booking,
                                };
                                dispatch(setGroupBooking(groupBookingPayload));
                              }

                              if (e.target.checked) {
                                setaffiliatedetailsAssigned([
                                  ...affiliatedetailsAssigned,
                                  {
                                    bookingId: booking?.bookingId,
                                    affiliateDetails:
                                      assignAffiliateDetail.affiliateId &&
                                      assignAffiliateDetail.affiliateId,

                                    affiliateNote:
                                      assignAffiliateDetail.affiliateNote &&
                                      assignAffiliateDetail.affiliateNote,

                                    afiliateAssignedAt: new Date(
                                      moment().format("YYYY-MM-DD HH:mm:ss")
                                    ).toISOString(),
                                    afiliateAssignedBy: user.userName,
                                    // purchasePrice: assignAffiliateDetail.purchasePrice,
                                    // purchaseCurrency: assignAffiliateDetail.purchaseCurrency,
                                  },
                                ]);

                                setassignedAffiliateSendVoucher([
                                  ...assignedAffiliateSendVoucher,
                                  {
                                    email: assignAffiliateMail,
                                    booking_id: booking?.bookingId,
                                    from: booking?.source?.placename,
                                    to: booking?.destination?.placename,
                                    timeAndDate:
                                      moment(booking?.travelDate).format(
                                        "DD-MM-YYYY"
                                      ) +
                                      " | " +
                                      booking?.travelTime,
                                    bookingType:
                                      booking?.bookingType
                                        ?.charAt(0)
                                        ?.toUpperCase() +
                                      booking?.bookingType
                                        ?.slice(1)
                                        .toLowerCase(),
                                    bookingStatus: booking?.bookingStatus,
                                    duration: booking?.duration,
                                    distance:
                                      Math.round(booking?.travelDistance) +
                                      " KM",
                                    flt_no:
                                      booking?.passengerDetails?.flightNumber,
                                    Reference_No:
                                      booking?.passengerDetails
                                        ?.referenceNumber,
                                    vehicleType:
                                      booking?.vehicleDetails?.categoryType,
                                    passengerName:
                                      booking?.passengerDetails?.firstName +
                                      " " +
                                      booking?.passengerDetails?.lastName,
                                    pax_email: booking?.passengerDetails?.email,
                                    mob_number:
                                      booking?.passengerDetails?.code +
                                      " " +
                                      booking?.passengerDetails?.phone,
                                    pax: booking?.passenger,
                                    emergency_number:
                                      settings?.emergencyContact1 +
                                      " " +
                                      settings?.emergencyContact2 +
                                      " " +
                                      settings?.emergencyContact3,
                                  },
                                ]);
                              } else {
                                setaffiliatedetailsAssigned(
                                  affiliatedetailsAssigned.filter(
                                    (item) =>
                                      item.bookingId !== booking?.bookingId
                                  )
                                );
                                setassignedAffiliateSendVoucher(
                                  assignedAffiliateSendVoucher.filter(
                                    (item) =>
                                      item.booking_id !== booking?.bookingId
                                  )
                                );
                              }
                            }}
                            onChangePPNote={(e) => {
                              //  add the affiliate details to the array which matches the booking id
                              setaffiliatedetailsAssigned(
                                affiliatedetailsAssigned.map((item) =>
                                  item.bookingId === booking?.bookingId
                                    ? {
                                        ...item,
                                        affiliateNote: e.target.value,
                                      }
                                    : item
                                )
                              );
                            }}
                            onChangePurchaseCurrency={(e) => {
                              setaffiliatedetailsAssigned(
                                affiliatedetailsAssigned.map((item) =>
                                  item.bookingId === booking?.bookingId
                                    ? {
                                        ...item,
                                        purchaseCurrency: e.target.value,
                                      }
                                    : item
                                )
                              );
                              setassignedAffiliateSendVoucher(
                                assignedAffiliateSendVoucher.map((item) =>
                                  item.booking_id === booking?.bookingId
                                    ? {
                                        ...item,
                                        purchaseCurrency: e.target.value,
                                      }
                                    : item
                                )
                              );
                            }}
                            onChangePurchasePrice={(e) => {
                              setaffiliatedetailsAssigned(
                                affiliatedetailsAssigned.map((item) =>
                                  item.bookingId === booking?.bookingId
                                    ? {
                                        ...item,
                                        purchasePrice: e.target.value,
                                      }
                                    : item
                                )
                              );
                              setassignedAffiliateSendVoucher(
                                assignedAffiliateSendVoucher.map((item) =>
                                  item.booking_id === booking?.bookingId
                                    ? {
                                        ...item,
                                        purchasePrice: e.target.value,
                                      }
                                    : item
                                )
                              );
                            }}
                            bookingId={booking?.bookingId}
                            Bookingtype={booking?.bookingType}
                            createdAt={booking?.createdAt}
                            pickupLocation={booking?.source?.placename}
                            dropofLocation={booking?.destination?.placename}
                            travelDate={booking?.travelDate}
                            travelDistance={booking?.travelDistance}
                            travelTime={booking?.travelTime}
                            amount={booking?.priceDetails?.amount}
                            currency={booking?.priceDetails?.currency}
                            invoiceNum={booking?.invoice_code_num}
                            vehicleImage={
                              booking?.vehicleDetails?.vehicleImage?.secure_url
                            }
                            bookingFor={booking?.bookingFor}
                            quoteBy={booking?.quoteBy}
                            driverDetails={booking?.driverDetails}
                            spreq={booking?.passengerDetails?.specialRequest}
                            duration={booking?.duration}
                            bookingStatus={booking?.bookingStatus}
                            vehicletype={booking?.vehicleDetails?.categoryType}
                            userName={booking?.userName}
                            affiliateDetails={booking?.affiliateDetails}
                            passengerFirstName={
                              booking?.passengerDetails?.firstName
                            }
                            passengerLastName={
                              booking?.passengerDetails?.lastName
                            }
                            indianDate={
                              booking?.indianTravelDate
                                ? booking?.indianTravelDate
                                : ""
                            }
                            indianTime={
                              booking?.indianTravelTime
                                ? booking?.indianTravelTime
                                : ""
                            }
                          />
                        </>
                      );
                    })}
                  </div>
                ) : (
                  <>
                    {jobsTab.allBookings &&
                      allSearchedBookings.length === 0 &&
                      searchedBookingCount === "" &&
                      allBookings?.map((booking) => {
                        return (
                          <>
                            <ManageBookingItem
                              ObjectBookingId={booking?._id}
                              extraPay={booking?.extraPay}
                              extraHour={booking?.extraHour}
                              totalPayment={booking?.totalPayment}
                              isBulkAssign={isBulkAssign}
                              isGroup={isGroup || groupIn || groupOut}
                              groupBookingObj={groupBooking}
                              groupBookingMark={booking?.isGroupBooking}
                              groupId={booking?.groupId}
                              affiliatePaymentStatus={booking?.affiliatePayment}
                              affiliateDetailsAssignedArr={
                                affiliatedetailsAssigned
                              }
                              onClickedCheckbox={(e) => {
                                let groupBookingPayload;

                                if (
                                  Object.keys(groupBooking).includes(
                                    booking?.bookingId
                                  )
                                ) {
                                  groupBookingPayload = {
                                    ...groupBooking,
                                  };
                                  delete groupBookingPayload[
                                    booking?.bookingId
                                  ];

                                  dispatch(
                                    setGroupBooking(groupBookingPayload)
                                  );
                                } else {
                                  groupBookingPayload = {
                                    ...groupBooking,
                                    [booking.bookingId]: booking,
                                  };
                                  dispatch(
                                    setGroupBooking(groupBookingPayload)
                                  );
                                }

                                if (e.target.checked) {
                                  setaffiliatedetailsAssigned([
                                    ...affiliatedetailsAssigned,
                                    {
                                      bookingId: booking?.bookingId,
                                      affiliateDetails:
                                        assignAffiliateDetail.affiliateId &&
                                        assignAffiliateDetail.affiliateId,

                                      affiliateNote:
                                        assignAffiliateDetail.affiliateNote &&
                                        assignAffiliateDetail.affiliateNote,

                                      afiliateAssignedAt: new Date(
                                        moment().format("YYYY-MM-DD HH:mm:ss")
                                      ).toISOString(),
                                      afiliateAssignedBy: user.userName,
                                      // purchasePrice: assignAffiliateDetail.purchasePrice,
                                      // purchaseCurrency: assignAffiliateDetail.purchaseCurrency,
                                    },
                                  ]);

                                  setassignedAffiliateSendVoucher([
                                    ...assignedAffiliateSendVoucher,
                                    {
                                      email: assignAffiliateMail,
                                      booking_id: booking?.bookingId,
                                      from: booking?.source?.placename,
                                      to: booking?.destination?.placename,
                                      timeAndDate:
                                        moment(booking?.travelDate).format(
                                          "DD-MM-YYYY"
                                        ) +
                                        " | " +
                                        booking?.travelTime,
                                      bookingType:
                                        booking?.bookingType
                                          ?.charAt(0)
                                          ?.toUpperCase() +
                                        booking?.bookingType
                                          ?.slice(1)
                                          .toLowerCase(),
                                      bookingStatus: booking?.bookingStatus,
                                      duration: booking?.duration,
                                      distance:
                                        Math.round(booking?.travelDistance) +
                                        " KM",
                                      flt_no:
                                        booking?.passengerDetails?.flightNumber,
                                      Reference_No:
                                        booking?.passengerDetails
                                          ?.referenceNumber,
                                      vehicleType:
                                        booking?.vehicleDetails?.categoryType,
                                      passengerName:
                                        booking?.passengerDetails?.firstName +
                                        " " +
                                        booking?.passengerDetails?.lastName,
                                      pax_email:
                                        booking?.passengerDetails?.email,
                                      mob_number:
                                        booking?.passengerDetails?.code +
                                        " " +
                                        booking?.passengerDetails?.phone,
                                      pax: booking?.passenger,
                                      emergency_number:
                                        settings?.emergencyContact1 +
                                        " " +
                                        settings?.emergencyContact2 +
                                        " " +
                                        settings?.emergencyContact3,
                                    },
                                  ]);
                                } else {
                                  setaffiliatedetailsAssigned(
                                    affiliatedetailsAssigned.filter(
                                      (item) =>
                                        item.bookingId !== booking?.bookingId
                                    )
                                  );
                                  setassignedAffiliateSendVoucher(
                                    assignedAffiliateSendVoucher.filter(
                                      (item) =>
                                        item.booking_id !== booking?.bookingId
                                    )
                                  );
                                }
                              }}
                              onChangePPNote={(e) => {
                                //  add the affiliate details to the array which matches the booking id
                                setaffiliatedetailsAssigned(
                                  affiliatedetailsAssigned.map((item) =>
                                    item.bookingId === booking?.bookingId
                                      ? {
                                          ...item,
                                          affiliateNote: e.target.value,
                                        }
                                      : item
                                  )
                                );
                              }}
                              onChangePurchaseCurrency={(e) => {
                                setaffiliatedetailsAssigned(
                                  affiliatedetailsAssigned.map((item) =>
                                    item.bookingId === booking?.bookingId
                                      ? {
                                          ...item,
                                          purchaseCurrency: e.target.value,
                                        }
                                      : item
                                  )
                                );
                                setassignedAffiliateSendVoucher(
                                  assignedAffiliateSendVoucher.map((item) =>
                                    item.booking_id === booking?.bookingId
                                      ? {
                                          ...item,
                                          purchaseCurrency: e.target.value,
                                        }
                                      : item
                                  )
                                );
                              }}
                              onChangePurchasePrice={(e) => {
                                setaffiliatedetailsAssigned(
                                  affiliatedetailsAssigned.map((item) =>
                                    item.bookingId === booking?.bookingId
                                      ? {
                                          ...item,
                                          purchasePrice: e.target.value,
                                        }
                                      : item
                                  )
                                );
                                setassignedAffiliateSendVoucher(
                                  assignedAffiliateSendVoucher.map((item) =>
                                    item.booking_id === booking?.bookingId
                                      ? {
                                          ...item,
                                          purchasePrice: e.target.value,
                                        }
                                      : item
                                  )
                                );
                              }}
                              bookingId={booking?.bookingId}
                              Bookingtype={booking?.bookingType}
                              createdAt={booking?.createdAt}
                              pickupLocation={booking?.source?.placename}
                              dropofLocation={booking?.destination?.placename}
                              travelDate={booking?.travelDate}
                              travelDistance={booking?.travelDistance}
                              travelTime={booking?.travelTime}
                              amount={booking?.priceDetails?.amount}
                              currency={booking?.priceDetails?.currency}
                              invoiceNum={booking?.invoice_code_num}
                              vehicleImage={
                                booking?.vehicleDetails?.vehicleImage
                                  ?.secure_url
                              }
                              bookingFor={booking?.bookingFor}
                              quoteBy={booking?.quoteBy}
                              driverDetails={booking?.driverDetails}
                              spreq={booking?.passengerDetails?.specialRequest}
                              duration={booking?.duration}
                              bookingStatus={booking?.bookingStatus}
                              vehicletype={
                                booking?.vehicleDetails?.categoryType
                              }
                              userName={booking?.userName}
                              affiliateDetails={booking?.affiliateDetails}
                              passengerFirstName={
                                booking?.passengerDetails?.firstName
                              }
                              passengerLastName={
                                booking?.passengerDetails?.lastName
                              }
                              indianDate={
                                booking?.indianTravelDate
                                  ? booking?.indianTravelDate
                                  : ""
                              }
                              indianTime={
                                booking?.indianTravelTime
                                  ? booking?.indianTravelTime
                                  : ""
                              }
                            />
                          </>
                        );
                      })}
                  </>
                )
              ) : (
                <>
                  <div className="px-20 space-y-5 flex-col justify-center">
                    <div className="flex space-x-3 ">
                      <div>
                        <Skeleton animation="wave" variant="text" width={550} />
                        <Skeleton animation="wave" variant="text" width={520} />
                        <Skeleton animation="wave" variant="text" width={550} />
                        <Skeleton animation="wave" variant="text" width={510} />
                      </div>
                      <Skeleton
                        animation="wave"
                        variant="rectangular"
                        width={210}
                        height={118}
                      />
                    </div>
                    <div className="flex space-x-3">
                      <div>
                        <Skeleton animation="wave" variant="text" width={550} />
                        <Skeleton animation="wave" variant="text" width={520} />
                        <Skeleton animation="wave" variant="text" width={550} />
                        <Skeleton animation="wave" variant="text" width={510} />
                      </div>
                      <Skeleton
                        animation="wave"
                        variant="rectangular"
                        width={210}
                        height={118}
                      />
                    </div>
                  </div>
                </>
              )}
              {!bookingIsloading &&
                jobsTab.jobsToday &&
                jobsForTodayBookings &&
                jobsForTodayBookings?.length === 0 && (
                  <div className="flex justify-center items-center h-[75vh]">
                    <div className="font-body text-2xl font-semibold">
                      No bookings for{" "}
                      <span className="text-[#fb4156]">Today</span>
                    </div>
                  </div>
                )}
              {jobsTab.jobsToday &&
                jobsForTodayBookings?.map((booking) => {
                  return (
                    <div className="relative">
                      {/* sort booking based on asia/kolkata time */}

                      <ManageBookingItem
                        ObjectBookingId={booking?._id}
                        extraPay={booking?.extraPay}
                        extraHour={booking?.extraHour}
                        totalPayment={booking?.totalPayment}
                        isBulkAssign={isBulkAssign}
                        isGroup={isGroup}
                        affiliatePaymentStatus={booking?.affiliatePayment}
                        groupBookingMark={booking?.isGroupBooking}
                        groupId={booking?.groupId}
                        affiliateDetailsAssignedArr={affiliatedetailsAssigned}
                        bookingFor={booking?.bookingFor}
                        quoteBy={booking?.quoteBy}
                        onClickedCheckbox={(e) => {
                          if (e.target.checked) {
                            setaffiliatedetailsAssigned([
                              ...affiliatedetailsAssigned,
                              {
                                bookingId: booking?.bookingId,
                                affiliateDetails:
                                  assignAffiliateDetail.affiliateId &&
                                  assignAffiliateDetail.affiliateId,

                                affiliateNote:
                                  assignAffiliateDetail.affiliateNote &&
                                  assignAffiliateDetail.affiliateNote,

                                afiliateAssignedAt: new Date(
                                  moment().format("YYYY-MM-DD HH:mm:ss")
                                ).toISOString(),
                                afiliateAssignedBy: user.userName,
                                // purchasePrice: assignAffiliateDetail.purchasePrice,
                                // purchaseCurrency: assignAffiliateDetail.purchaseCurrency,
                              },
                            ]);
                            setassignedAffiliateSendVoucher([
                              ...assignedAffiliateSendVoucher,
                              {
                                company_name: allCompany?.map((company) => {
                                  return company?.users?.map((user) => {
                                    return (
                                      user?.userName === booking?.userName &&
                                      company?.companyName
                                    );
                                  });
                                }),
                                email: assignAffiliateMail,
                                booking_id: booking?.bookingId,
                                from: booking?.source?.placename,
                                to: booking?.destination?.placename,
                                timeAndDate:
                                  moment(booking?.travelDate).format(
                                    "DD-MM-YYYY"
                                  ) +
                                  " | " +
                                  booking?.travelTime,
                                bookingType:
                                  booking?.bookingType
                                    ?.charAt(0)
                                    ?.toUpperCase() +
                                  booking?.bookingType?.slice(1).toLowerCase(),
                                bookingStatus: booking?.bookingStatus,
                                distance:
                                  Math.round(booking?.travelDistance) + " KM",
                                flt_no: booking?.passengerDetails?.flightNumber,
                                Reference_No:
                                  booking?.passengerDetails?.referenceNumber,
                                vehicleType:
                                  booking?.vehicleDetails?.categoryType,
                                passengerName:
                                  booking?.passengerDetails?.firstName +
                                  " " +
                                  booking?.passengerDetails?.lastName,
                                pax_email: booking?.passengerDetails?.email,

                                mob_number:
                                  booking?.passengerDetails?.code +
                                  " " +
                                  booking?.passengerDetails?.phone,
                                pax: booking?.passenger,
                                emergency_number:
                                  settings?.emergencyContact1 +
                                  " " +
                                  settings?.emergencyContact2 +
                                  " " +
                                  settings?.emergencyContact3,
                              },
                            ]);
                          } else {
                            setaffiliatedetailsAssigned(
                              affiliatedetailsAssigned.filter(
                                (item) => item.bookingId !== booking?.bookingId
                              )
                            );
                            setassignedAffiliateSendVoucher(
                              assignedAffiliateSendVoucher.filter(
                                (item) => item.booking_id !== booking?.bookingId
                              )
                            );
                          }
                        }}
                        onChangePPNote={(e) => {
                          //  add the affiliate details to the array which matches the booking id
                          setaffiliatedetailsAssigned(
                            affiliatedetailsAssigned.map((item) =>
                              item.bookingId === booking?.bookingId
                                ? {
                                    ...item,
                                    affiliateNote: e.target.value,
                                  }
                                : item
                            )
                          );
                        }}
                        onChangePurchaseCurrency={(e) => {
                          setaffiliatedetailsAssigned(
                            affiliatedetailsAssigned.map((item) =>
                              item.bookingId === booking?.bookingId
                                ? {
                                    ...item,
                                    purchaseCurrency: e.target.value,
                                  }
                                : item
                            )
                          );
                          setassignedAffiliateSendVoucher(
                            assignedAffiliateSendVoucher.map((item) =>
                              item.booking_id === booking?.bookingId
                                ? {
                                    ...item,
                                    purchaseCurrency: e.target.value,
                                  }
                                : item
                            )
                          );
                        }}
                        onChangePurchasePrice={(e) => {
                          setaffiliatedetailsAssigned(
                            affiliatedetailsAssigned.map((item) =>
                              item.bookingId === booking?.bookingId
                                ? {
                                    ...item,
                                    purchasePrice: e.target.value,
                                  }
                                : item
                            )
                          );
                          setassignedAffiliateSendVoucher(
                            assignedAffiliateSendVoucher.map((item) =>
                              item.booking_id === booking?.bookingId
                                ? {
                                    ...item,
                                    purchasePrice: e.target.value,
                                  }
                                : item
                            )
                          );
                        }}
                        bookingId={booking?.bookingId}
                        invoiceNum={booking?.invoice_code_num}
                        Bookingtype={booking?.bookingType}
                        createdAt={booking?.createdAt}
                        pickupLocation={booking?.source?.placename}
                        dropofLocation={booking?.destination?.placename}
                        travelDate={booking?.travelDate}
                        travelDistance={booking?.travelDistance}
                        travelTime={booking?.travelTime}
                        amount={booking?.priceDetails?.amount}
                        currency={booking?.priceDetails?.currency}
                        vehicleImage={
                          booking?.vehicleDetails?.vehicleImage?.secure_url
                        }
                        driverDetails={booking?.driverDetails}
                        spreq={booking?.passengerDetails?.specialRequest}
                        duration={booking?.duration}
                        bookingStatus={booking?.bookingStatus}
                        vehicletype={booking?.vehicleDetails?.categoryType}
                        userName={booking?.userName}
                        affiliateDetails={booking?.affiliateDetails}
                        passengerFirstName={
                          booking?.passengerDetails?.firstName
                        }
                        passengerLastName={booking?.passengerDetails?.lastName}
                        indianDate={
                          booking?.indianTravelDate
                            ? booking?.indianTravelDate
                            : ""
                        }
                        indianTime={
                          booking?.indianTravelTime
                            ? booking?.indianTravelTime
                            : ""
                        }
                      />
                      {user.role === "ADMIN" && (
                        <div className="flex items-center w-full sm:w-1/3 absolute top-14 sm:top-9 right-3  text-green-600  space-x-1 px-2 justify-end sm:justify-center  mx-auto text-center   py-1 rounded-sm">
                          <div>(</div>
                          <div className=" text-xs font-semibold  ">IST:</div>
                          <div className=" text-xs font-semibold">
                            {momenttz(booking?.travelTimeStamp)
                              .tz("Asia/Kolkata")
                              // .format("MMMM Do YYYY, h:mm a")
                              .format("DD-MM-YYYY, h:mm a")}
                          </div>
                          <div>)</div>
                        </div>
                      )}
                    </div>
                  );
                })}
              {jobsTab.paymentPending &&
                affiliatePaymentPendingBookings.map((booking) => {
                  return (
                    <div className="relative">
                      <ManageBookingItem
                        ObjectBookingId={booking?._id}
                        extraPay={booking?.extraPay}
                        extraHour={booking?.extraHour}
                        totalPayment={booking?.totalPayment}
                        isBulkAssign={isBulkAssign}
                        isGroup={isGroup}
                        affiliatePaymentStatus={booking?.affiliatePayment}
                        groupBookingMark={booking?.isGroupBooking}
                        groupId={booking?.groupId}
                        affiliateDetailsAssignedArr={affiliatedetailsAssigned}
                        bookingFor={booking?.bookingFor}
                        onClickedCheckbox={(e) => {
                          if (e.target.checked) {
                            setaffiliatedetailsAssigned([
                              ...affiliatedetailsAssigned,
                              {
                                bookingId: booking?.bookingId,
                                affiliateDetails:
                                  assignAffiliateDetail.affiliateId &&
                                  assignAffiliateDetail.affiliateId,

                                affiliateNote:
                                  assignAffiliateDetail.affiliateNote &&
                                  assignAffiliateDetail.affiliateNote,

                                afiliateAssignedAt: new Date(
                                  moment().format("YYYY-MM-DD HH:mm:ss")
                                ).toISOString(),
                                afiliateAssignedBy: user.userName,
                                // purchasePrice: assignAffiliateDetail.purchasePrice,
                                // purchaseCurrency: assignAffiliateDetail.purchaseCurrency,
                              },
                            ]);
                            setassignedAffiliateSendVoucher([
                              ...assignedAffiliateSendVoucher,
                              {
                                company_name: allCompany?.map((company) => {
                                  return company?.users?.map((user) => {
                                    return (
                                      user?.userName === booking?.userName &&
                                      company?.companyName
                                    );
                                  });
                                }),
                                email: assignAffiliateMail,
                                booking_id: booking?.bookingId,
                                from: booking?.source?.placename,
                                to: booking?.destination?.placename,
                                timeAndDate:
                                  moment(booking?.travelDate).format(
                                    "DD-MM-YYYY"
                                  ) +
                                  " | " +
                                  booking?.travelTime,
                                bookingType:
                                  booking?.bookingType
                                    ?.charAt(0)
                                    ?.toUpperCase() +
                                  booking?.bookingType?.slice(1).toLowerCase(),
                                bookingStatus: booking?.bookingStatus,
                                distance:
                                  Math.round(booking?.travelDistance) + " KM",
                                flt_no: booking?.passengerDetails?.flightNumber,
                                Reference_No:
                                  booking?.passengerDetails?.referenceNumber,
                                vehicleType:
                                  booking?.vehicleDetails?.categoryType,
                                passengerName:
                                  booking?.passengerDetails?.firstName +
                                  " " +
                                  booking?.passengerDetails?.lastName,
                                pax_email: booking?.passengerDetails?.email,

                                mob_number:
                                  booking?.passengerDetails?.code +
                                  " " +
                                  booking?.passengerDetails?.phone,
                                pax: booking?.passenger,
                                emergency_number:
                                  settings?.emergencyContact1 +
                                  " " +
                                  settings?.emergencyContact2 +
                                  " " +
                                  settings?.emergencyContact3,
                              },
                            ]);
                          } else {
                            setaffiliatedetailsAssigned(
                              affiliatedetailsAssigned.filter(
                                (item) => item.bookingId !== booking?.bookingId
                              )
                            );
                            setassignedAffiliateSendVoucher(
                              assignedAffiliateSendVoucher.filter(
                                (item) => item.booking_id !== booking?.bookingId
                              )
                            );
                          }
                        }}
                        onChangePPNote={(e) => {
                          //  add the affiliate details to the array which matches the booking id
                          setaffiliatedetailsAssigned(
                            affiliatedetailsAssigned.map((item) =>
                              item.bookingId === booking?.bookingId
                                ? {
                                    ...item,
                                    affiliateNote: e.target.value,
                                  }
                                : item
                            )
                          );
                        }}
                        onChangePurchaseCurrency={(e) => {
                          setaffiliatedetailsAssigned(
                            affiliatedetailsAssigned.map((item) =>
                              item.bookingId === booking?.bookingId
                                ? {
                                    ...item,
                                    purchaseCurrency: e.target.value,
                                  }
                                : item
                            )
                          );
                          setassignedAffiliateSendVoucher(
                            assignedAffiliateSendVoucher.map((item) =>
                              item.booking_id === booking?.bookingId
                                ? {
                                    ...item,
                                    purchaseCurrency: e.target.value,
                                  }
                                : item
                            )
                          );
                        }}
                        onChangePurchasePrice={(e) => {
                          setaffiliatedetailsAssigned(
                            affiliatedetailsAssigned.map((item) =>
                              item.bookingId === booking?.bookingId
                                ? {
                                    ...item,
                                    purchasePrice: e.target.value,
                                  }
                                : item
                            )
                          );
                          setassignedAffiliateSendVoucher(
                            assignedAffiliateSendVoucher.map((item) =>
                              item.booking_id === booking?.bookingId
                                ? {
                                    ...item,
                                    purchasePrice: e.target.value,
                                  }
                                : item
                            )
                          );
                        }}
                        bookingId={booking?.bookingId}
                        invoiceNum={booking?.invoice_code_num}
                        Bookingtype={booking?.bookingType}
                        createdAt={booking?.createdAt}
                        pickupLocation={booking?.source?.placename}
                        dropofLocation={booking?.destination?.placename}
                        travelDate={booking?.travelDate}
                        travelDistance={booking?.travelDistance}
                        travelTime={booking?.travelTime}
                        amount={booking?.priceDetails?.amount}
                        currency={booking?.priceDetails?.currency}
                        vehicleImage={
                          booking?.vehicleDetails?.vehicleImage?.secure_url
                        }
                        driverDetails={booking?.driverDetails}
                        spreq={booking?.passengerDetails?.specialRequest}
                        duration={booking?.duration}
                        bookingStatus={booking?.bookingStatus}
                        vehicletype={booking?.vehicleDetails?.categoryType}
                        userName={booking?.userName}
                        affiliateDetails={booking?.affiliateDetails}
                        passengerFirstName={
                          booking?.passengerDetails?.firstName
                        }
                        passengerLastName={booking?.passengerDetails?.lastName}
                        indianDate={
                          booking?.indianTravelDate
                            ? booking?.indianTravelDate
                            : ""
                        }
                        indianTime={
                          booking?.indianTravelTime
                            ? booking?.indianTravelTime
                            : ""
                        }
                      />
                    </div>
                  );
                })}
              {jobsTab.inprogressJobs &&
                pobBookings?.map((booking) => {
                  return (
                    <div className="relative">
                      {/* sort booking based on asia/kolkata time */}

                      <ManageBookingItem
                        ObjectBookingId={booking?._id}
                        extraPay={booking?.extraPay}
                        extraHour={booking?.extraHour}
                        totalPayment={booking?.totalPayment}
                        isBulkAssign={isBulkAssign}
                        isGroup={isGroup}
                        groupBookingMark={booking?.isGroupBooking}
                        groupId={booking?.groupId}
                        affiliateDetailsAssignedArr={affiliatedetailsAssigned}
                        bookingFor={booking?.bookingFor}
                        quoteBy={booking?.quoteBy}
                        onClickedCheckbox={(e) => {
                          if (e.target.checked) {
                            setaffiliatedetailsAssigned([
                              ...affiliatedetailsAssigned,
                              {
                                bookingId: booking?.bookingId,
                                affiliateDetails:
                                  assignAffiliateDetail.affiliateId &&
                                  assignAffiliateDetail.affiliateId,

                                affiliateNote:
                                  assignAffiliateDetail.affiliateNote &&
                                  assignAffiliateDetail.affiliateNote,

                                afiliateAssignedAt: new Date(
                                  moment().format("YYYY-MM-DD HH:mm:ss")
                                ).toISOString(),
                                afiliateAssignedBy: user.userName,
                                // purchasePrice: assignAffiliateDetail.purchasePrice,
                                // purchaseCurrency: assignAffiliateDetail.purchaseCurrency,
                              },
                            ]);
                            setassignedAffiliateSendVoucher([
                              ...assignedAffiliateSendVoucher,
                              {
                                company_name: allCompany?.map((company) => {
                                  return company?.users?.map((user) => {
                                    return (
                                      user?.userName === booking?.userName &&
                                      company?.companyName
                                    );
                                  });
                                }),
                                email: assignAffiliateMail,
                                booking_id: booking?.bookingId,
                                from: booking?.source?.placename,
                                to: booking?.destination?.placename,
                                timeAndDate:
                                  moment(booking?.travelDate).format(
                                    "DD-MM-YYYY"
                                  ) +
                                  " | " +
                                  booking?.travelTime,
                                bookingType:
                                  booking?.bookingType
                                    ?.charAt(0)
                                    ?.toUpperCase() +
                                  booking?.bookingType?.slice(1).toLowerCase(),
                                bookingStatus: booking?.bookingStatus,
                                distance:
                                  Math.round(booking?.travelDistance) + " KM",
                                flt_no: booking?.passengerDetails?.flightNumber,
                                Reference_No:
                                  booking?.passengerDetails?.referenceNumber,
                                vehicleType:
                                  booking?.vehicleDetails?.categoryType,
                                passengerName:
                                  booking?.passengerDetails?.firstName +
                                  " " +
                                  booking?.passengerDetails?.lastName,
                                pax_email: booking?.passengerDetails?.email,

                                mob_number:
                                  booking?.passengerDetails?.code +
                                  " " +
                                  booking?.passengerDetails?.phone,
                                pax: booking?.passenger,
                                emergency_number:
                                  settings?.emergencyContact1 +
                                  " " +
                                  settings?.emergencyContact2 +
                                  " " +
                                  settings?.emergencyContact3,
                              },
                            ]);
                          } else {
                            setaffiliatedetailsAssigned(
                              affiliatedetailsAssigned.filter(
                                (item) => item.bookingId !== booking?.bookingId
                              )
                            );
                            setassignedAffiliateSendVoucher(
                              assignedAffiliateSendVoucher.filter(
                                (item) => item.booking_id !== booking?.bookingId
                              )
                            );
                          }
                        }}
                        onChangePPNote={(e) => {
                          //  add the affiliate details to the array which matches the booking id
                          setaffiliatedetailsAssigned(
                            affiliatedetailsAssigned.map((item) =>
                              item.bookingId === booking?.bookingId
                                ? {
                                    ...item,
                                    affiliateNote: e.target.value,
                                  }
                                : item
                            )
                          );
                        }}
                        onChangePurchaseCurrency={(e) => {
                          setaffiliatedetailsAssigned(
                            affiliatedetailsAssigned.map((item) =>
                              item.bookingId === booking?.bookingId
                                ? {
                                    ...item,
                                    purchaseCurrency: e.target.value,
                                  }
                                : item
                            )
                          );
                          setassignedAffiliateSendVoucher(
                            assignedAffiliateSendVoucher.map((item) =>
                              item.booking_id === booking?.bookingId
                                ? {
                                    ...item,
                                    purchaseCurrency: e.target.value,
                                  }
                                : item
                            )
                          );
                        }}
                        onChangePurchasePrice={(e) => {
                          setaffiliatedetailsAssigned(
                            affiliatedetailsAssigned.map((item) =>
                              item.bookingId === booking?.bookingId
                                ? {
                                    ...item,
                                    purchasePrice: e.target.value,
                                  }
                                : item
                            )
                          );
                          setassignedAffiliateSendVoucher(
                            assignedAffiliateSendVoucher.map((item) =>
                              item.booking_id === booking?.bookingId
                                ? {
                                    ...item,
                                    purchasePrice: e.target.value,
                                  }
                                : item
                            )
                          );
                        }}
                        bookingId={booking?.bookingId}
                        invoiceNum={booking?.invoice_code_num}
                        Bookingtype={booking?.bookingType}
                        createdAt={booking?.createdAt}
                        pickupLocation={booking?.source?.placename}
                        dropofLocation={booking?.destination?.placename}
                        travelDate={booking?.travelDate}
                        travelDistance={booking?.travelDistance}
                        travelTime={booking?.travelTime}
                        amount={booking?.priceDetails?.amount}
                        currency={booking?.priceDetails?.currency}
                        vehicleImage={
                          booking?.vehicleDetails?.vehicleImage?.secure_url
                        }
                        driverDetails={booking?.driverDetails}
                        spreq={booking?.passengerDetails?.specialRequest}
                        duration={booking?.duration}
                        bookingStatus={booking?.bookingStatus}
                        vehicletype={booking?.vehicleDetails?.categoryType}
                        userName={booking?.userName}
                        affiliateDetails={booking?.affiliateDetails}
                        passengerFirstName={
                          booking?.passengerDetails?.firstName
                        }
                        passengerLastName={booking?.passengerDetails?.lastName}
                        indianDate={
                          booking?.indianTravelDate
                            ? booking?.indianTravelDate
                            : ""
                        }
                        indianTime={
                          booking?.indianTravelTime
                            ? booking?.indianTravelTime
                            : ""
                        }
                      />
                      {user.role === "ADMIN" && (
                        <div className="flex items-center w-full sm:w-1/3 absolute top-14 sm:top-9 right-3  text-green-600  space-x-1 px-2 justify-end sm:justify-center  mx-auto text-center   py-1 rounded-sm">
                          <div>(</div>
                          <div className=" text-xs font-semibold  ">IST:</div>
                          <div className=" text-xs font-semibold">
                            {momenttz(booking?.travelTimeStamp)
                              .tz("Asia/Kolkata")
                              // .format("MMMM Do YYYY, h:mm a")
                              .format("DD-MM-YYYY, h:mm a")}
                          </div>
                          <div>)</div>
                        </div>
                      )}
                    </div>
                  );
                })}
              {jobsTab.jobsTomorrow &&
                jobsForTomorrowBookings &&
                jobsForTomorrowBookings.length === 0 && (
                  <div className="flex justify-center items-center h-[75vh]">
                    <div className="font-body text-2xl font-semibold">
                      No bookings for{" "}
                      <span className="text-[#fb4156]">Tomorrow</span>
                    </div>
                  </div>
                )}
              {jobsTab.jobsTomorrow &&
                jobsForTomorrowBookings?.map((booking) => {
                  return (
                    <div className="relative">
                      <ManageBookingItem
                        ObjectBookingId={booking?._id}
                        extraPay={booking?.extraPay}
                        extraHour={booking?.extraHour}
                        totalPayment={booking?.totalPayment}
                        isBulkAssign={isBulkAssign}
                        isGroup={isGroup}
                        groupBookingMark={booking?.isGroupBooking}
                        groupId={booking?.groupId}
                        affiliateDetailsAssignedArr={affiliatedetailsAssigned}
                        bookingFor={booking?.bookingFor}
                        affiliatePaymentStatus={booking?.affiliatePayment}
                        quoteBy={booking?.quoteBy}
                        onClickedCheckbox={(e) => {
                          if (e.target.checked) {
                            setaffiliatedetailsAssigned([
                              ...affiliatedetailsAssigned,
                              {
                                bookingId: booking?.bookingId,
                                affiliateDetails:
                                  assignAffiliateDetail.affiliateId &&
                                  assignAffiliateDetail.affiliateId,

                                affiliateNote:
                                  assignAffiliateDetail.affiliateNote &&
                                  assignAffiliateDetail.affiliateNote,

                                afiliateAssignedAt: new Date(
                                  moment().format("YYYY-MM-DD HH:mm:ss")
                                ).toISOString(),
                                afiliateAssignedBy: user.userName,
                                // purchasePrice: assignAffiliateDetail.purchasePrice,
                                // purchaseCurrency: assignAffiliateDetail.purchaseCurrency,
                              },
                            ]);
                            setassignedAffiliateSendVoucher([
                              ...assignedAffiliateSendVoucher,
                              {
                                company_name: allCompany?.map((company) => {
                                  return company?.users?.map((user) => {
                                    return (
                                      user?.userName === booking?.userName &&
                                      company?.companyName
                                    );
                                  });
                                }),
                                email: assignAffiliateMail,
                                booking_id: booking?.bookingId,
                                from: booking?.source?.placename,
                                to: booking?.destination?.placename,
                                timeAndDate:
                                  moment(booking?.travelDate).format(
                                    "DD-MM-YYYY"
                                  ) +
                                  " | " +
                                  booking?.travelTime,
                                bookingType:
                                  booking?.bookingType
                                    ?.charAt(0)
                                    ?.toUpperCase() +
                                  booking?.bookingType?.slice(1).toLowerCase(),
                                bookingStatus: booking?.bookingStatus,
                                distance:
                                  Math.round(booking?.travelDistance) + " KM",
                                flt_no: booking?.passengerDetails?.flightNumber,
                                Reference_No:
                                  booking?.passengerDetails?.referenceNumber,
                                vehicleType:
                                  booking?.vehicleDetails?.categoryType,
                                passengerName:
                                  booking?.passengerDetails?.firstName +
                                  " " +
                                  booking?.passengerDetails?.lastName,
                                pax_email: booking?.passengerDetails?.email,
                                mob_number:
                                  booking?.passengerDetails?.code +
                                  " " +
                                  booking?.passengerDetails?.phone,
                                pax: booking?.passenger,
                                emergency_number:
                                  settings?.emergencyContact1 +
                                  " " +
                                  settings?.emergencyContact2 +
                                  " " +
                                  settings?.emergencyContact3,
                              },
                            ]);
                          } else {
                            setaffiliatedetailsAssigned(
                              affiliatedetailsAssigned.filter(
                                (item) => item.bookingId !== booking?.bookingId
                              )
                            );
                            setassignedAffiliateSendVoucher(
                              assignedAffiliateSendVoucher.filter(
                                (item) => item.booking_id !== booking?.bookingId
                              )
                            );
                          }
                        }}
                        onChangePPNote={(e) => {
                          //  add the affiliate details to the array which matches the booking id
                          setaffiliatedetailsAssigned(
                            affiliatedetailsAssigned.map((item) =>
                              item.bookingId === booking?.bookingId
                                ? {
                                    ...item,
                                    affiliateNote: e.target.value,
                                  }
                                : item
                            )
                          );
                        }}
                        onChangePurchaseCurrency={(e) => {
                          setaffiliatedetailsAssigned(
                            affiliatedetailsAssigned.map((item) =>
                              item.bookingId === booking?.bookingId
                                ? {
                                    ...item,
                                    purchaseCurrency: e.target.value,
                                  }
                                : item
                            )
                          );
                          setassignedAffiliateSendVoucher(
                            assignedAffiliateSendVoucher.map((item) =>
                              item.booking_id === booking?.bookingId
                                ? {
                                    ...item,
                                    purchaseCurrency: e.target.value,
                                  }
                                : item
                            )
                          );
                        }}
                        onChangePurchasePrice={(e) => {
                          setaffiliatedetailsAssigned(
                            affiliatedetailsAssigned.map((item) =>
                              item.bookingId === booking?.bookingId
                                ? {
                                    ...item,
                                    purchasePrice: e.target.value,
                                  }
                                : item
                            )
                          );
                          setassignedAffiliateSendVoucher(
                            assignedAffiliateSendVoucher.map((item) =>
                              item.booking_id === booking?.bookingId
                                ? {
                                    ...item,
                                    purchasePrice: e.target.value,
                                  }
                                : item
                            )
                          );
                        }}
                        bookingId={booking?.bookingId}
                        Bookingtype={booking?.bookingType}
                        invoiceNum={booking?.invoice_code_num}
                        createdAt={booking?.createdAt}
                        pickupLocation={booking?.source?.placename}
                        dropofLocation={booking?.destination?.placename}
                        travelDate={booking?.travelDate}
                        travelDistance={booking?.travelDistance}
                        travelTime={booking?.travelTime}
                        amount={booking?.priceDetails?.amount}
                        currency={booking?.priceDetails?.currency}
                        vehicleImage={
                          booking?.vehicleDetails?.vehicleImage?.secure_url
                        }
                        driverDetails={booking?.driverDetails}
                        spreq={booking?.passengerDetails?.specialRequest}
                        duration={booking?.duration}
                        bookingStatus={booking?.bookingStatus}
                        vehicletype={booking?.vehicleDetails?.categoryType}
                        userName={booking?.userName}
                        affiliateDetails={booking?.affiliateDetails}
                        passengerFirstName={
                          booking?.passengerDetails?.firstName
                        }
                        passengerLastName={booking?.passengerDetails?.lastName}
                        indianDate={
                          booking?.indianTravelDate
                            ? booking?.indianTravelDate
                            : ""
                        }
                        indianTime={
                          booking?.indianTravelTime
                            ? booking?.indianTravelTime
                            : ""
                        }
                      />
                      {user.role === "ADMIN" && (
                        <div className="flex items-center  absolute top-9 right-20  text-green-600  space-x-1 px-2 w-1/3 justify-center mx-auto text-center   py-1 rounded-sm">
                          <div>(</div>
                          <div className=" text-xs font-semibold  ">IST:</div>
                          <div className=" text-xs font-semibold">
                            {momenttz(booking?.travelTimeStamp)
                              .tz("Asia/Kolkata")
                              // .format("MMMM Do YYYY, h:mm a")
                              .format("DD-MM-YYYY, h:mm a")}
                          </div>
                          <div>)</div>
                        </div>
                      )}
                    </div>
                  );
                })}

              {jobsTab.unassignedJobs &&
                unassignedJobs &&
                unassignedJobs.length === 0 && (
                  <div className="flex justify-center items-center h-[75vh]">
                    <div className="font-body text-2xl font-semibold">
                      No Unassigned Bookings
                    </div>
                  </div>
                )}
              {jobsTab.unassignedJobs &&
                unassignedJobs?.map((booking) => {
                  return (
                    <>
                      <ManageBookingItem
                        ObjectBookingId={booking?._id}
                        extraPay={booking?.extraPay}
                        extraHour={booking?.extraHour}
                        totalPayment={booking?.totalPayment}
                        isBulkAssign={isBulkAssign}
                        isGroup={isGroup}
                        groupBookingMark={booking?.isGroupBooking}
                        groupId={booking?.groupId}
                        affiliateDetailsAssignedArr={affiliatedetailsAssigned}
                        bookingFor={booking?.bookingFor}
                        quoteBy={booking?.quoteBy}
                        invoiceNum={booking?.invoice_code_num}
                        onClickedCheckbox={(e) => {
                          if (e.target.checked) {
                            setdocketarr([
                              ...docketarr,
                              {
                                bookingId: booking?.bookingId,
                                travelDate: booking?.travelDate,
                                bookingType: booking?.bookingType,
                                tripNotes: `
                                  Pickup: ${booking?.source?.placename} 
                                  Dropoff: ${booking?.destination?.placename}
                                  Booking Type: ${
                                    booking?.bookingType
                                      ?.charAt(0)
                                      ?.toUpperCase() +
                                    booking?.bookingType?.slice(1).toLowerCase()
                                  }
                                  Passenger Name: ${
                                    booking?.passengerDetails?.firstName +
                                    " " +
                                    booking?.passengerDetails?.lastName
                                  }
                                `,
                                sellingPriceCurrency:
                                  booking?.priceDetails?.currency,
                                sellingPrice: booking?.priceDetails?.amount,
                                // sellingPriceRemarks: "This is selling remarks",
                                purchasePriceCurrency:
                                  assignAffiliateDetail.purchaseCurrency,
                                purchasePrice:
                                  assignAffiliateDetail.purchasePrice,
                                purchasePriceRemarks:
                                  assignAffiliateDetail.affiliateNote,

                                passengerName:
                                  booking?.passengerDetails?.firstName +
                                  " " +
                                  booking?.passengerDetails?.lastName,
                                status: "OK",
                              },
                            ]);

                            setaffiliatedetailsAssigned([
                              ...affiliatedetailsAssigned,
                              {
                                bookingId: booking?.bookingId,
                                affiliateDetails:
                                  assignAffiliateDetail.affiliateId &&
                                  assignAffiliateDetail.affiliateId,

                                affiliateNote:
                                  assignAffiliateDetail.affiliateNote &&
                                  assignAffiliateDetail.affiliateNote,

                                afiliateAssignedAt: new Date(
                                  moment().format("YYYY-MM-DD HH:mm:ss")
                                ).toISOString(),
                                afiliateAssignedBy: user.userName,
                                // purchasePrice: assignAffiliateDetail.purchasePrice,
                                // purchaseCurrency: assignAffiliateDetail.purchaseCurrency,
                              },
                            ]);
                            setassignedAffiliateSendVoucher([
                              ...assignedAffiliateSendVoucher,
                              {
                                company_name: allCompany?.map((company) => {
                                  return company?.users?.map((user) => {
                                    return (
                                      user?.userName === booking?.userName &&
                                      company?.companyName
                                    );
                                  });
                                }),
                                email: assignAffiliateMail,
                                booking_id: booking?.bookingId,
                                from: booking?.source?.placename,
                                to: booking?.destination?.placename,
                                timeAndDate:
                                  moment(booking?.travelDate).format(
                                    "DD-MM-YYYY"
                                  ) +
                                  " | " +
                                  booking?.travelTime,
                                bookingType:
                                  booking?.bookingType
                                    ?.charAt(0)
                                    ?.toUpperCase() +
                                  booking?.bookingType?.slice(1).toLowerCase(),
                                bookingStatus: booking?.bookingStatus,
                                distance:
                                  Math.round(booking?.travelDistance) + " KM",
                                flt_no: booking?.passengerDetails?.flightNumber,
                                Reference_No:
                                  booking?.passengerDetails?.referenceNumber,
                                vehicleType:
                                  booking?.vehicleDetails?.categoryType,
                                passengerName:
                                  booking?.passengerDetails?.firstName +
                                  " " +
                                  booking?.passengerDetails?.lastName,
                                pax_email: booking?.passengerDetails?.email,
                                mob_number:
                                  booking?.passengerDetails?.code +
                                  " " +
                                  booking?.passengerDetails?.phone,
                                pax: booking?.passenger,
                                emergency_number:
                                  settings?.emergencyContact1 +
                                  " " +
                                  settings?.emergencyContact2 +
                                  " " +
                                  settings?.emergencyContact3,
                              },
                            ]);
                          } else {
                            setaffiliatedetailsAssigned(
                              affiliatedetailsAssigned.filter(
                                (item) => item.bookingId !== booking?.bookingId
                              )
                            );
                            setdocketarr(
                              docketarr.filter(
                                (item) => item.bookingId !== booking?.bookingId
                              )
                            );
                            setassignedAffiliateSendVoucher(
                              assignedAffiliateSendVoucher.filter(
                                (item) => item.booking_id !== booking?.bookingId
                              )
                            );
                          }
                        }}
                        onChangePPNote={(e) => {
                          //  add the affiliate details to the array which matches the booking id
                          setaffiliatedetailsAssigned(
                            affiliatedetailsAssigned.map((item) =>
                              item.bookingId === booking?.bookingId
                                ? {
                                    ...item,
                                    affiliateNote: e.target.value,
                                  }
                                : item
                            )
                          );
                        }}
                        onChangePurchaseCurrency={(e) => {
                          setaffiliatedetailsAssigned(
                            affiliatedetailsAssigned.map((item) =>
                              item.bookingId === booking?.bookingId
                                ? {
                                    ...item,
                                    purchaseCurrency: e.target.value,
                                  }
                                : item
                            )
                          );
                          setassignedAffiliateSendVoucher(
                            assignedAffiliateSendVoucher.map((item) =>
                              item.booking_id === booking?.bookingId
                                ? {
                                    ...item,
                                    purchaseCurrency: e.target.value,
                                  }
                                : item
                            )
                          );
                        }}
                        onChangePurchasePrice={(e) => {
                          setaffiliatedetailsAssigned(
                            affiliatedetailsAssigned.map((item) =>
                              item.bookingId === booking?.bookingId
                                ? {
                                    ...item,
                                    purchasePrice: e.target.value,
                                  }
                                : item
                            )
                          );
                          setassignedAffiliateSendVoucher(
                            assignedAffiliateSendVoucher.map((item) =>
                              item.booking_id === booking?.bookingId
                                ? {
                                    ...item,
                                    purchasePrice: e.target.value,
                                  }
                                : item
                            )
                          );
                        }}
                        bookingId={booking?.bookingId}
                        Bookingtype={booking?.bookingType}
                        createdAt={booking?.createdAt}
                        pickupLocation={booking?.source?.placename}
                        dropofLocation={booking?.destination?.placename}
                        travelDate={booking?.travelDate}
                        travelDistance={booking?.travelDistance}
                        travelTime={booking?.travelTime}
                        amount={booking?.priceDetails?.amount}
                        currency={booking?.priceDetails?.currency}
                        vehicleImage={
                          booking?.vehicleDetails?.vehicleImage?.secure_url
                        }
                        driverDetails={booking?.driverDetails}
                        spreq={booking?.passengerDetails?.specialRequest}
                        duration={booking?.duration}
                        bookingStatus={booking?.bookingStatus}
                        vehicletype={booking?.vehicleDetails?.categoryType}
                        userName={booking?.userName}
                        affiliateDetails={booking?.affiliateDetails}
                        passengerFirstName={
                          booking?.passengerDetails?.firstName
                        }
                        passengerLastName={booking?.passengerDetails?.lastName}
                        indianDate={
                          booking?.indianTravelDate
                            ? booking?.indianTravelDate
                            : ""
                        }
                        indianTime={
                          booking?.indianTravelTime
                            ? booking?.indianTravelTime
                            : ""
                        }
                      />
                    </>
                  );
                })}
              <div className="pb-52">
                <div className="flex space-x-3 pt-3 justify-between px-10">
                  {/* <div
                    onClick={() => {
                      dispatch(setPagePrev());
                    }}
                    className="flex space-x-2 items-center cursor-pointer  "
                  >
                    <FontAwesomeIcon icon={faArrowAltCircleLeft} />
                    <div className="">Prev</div>
                  </div> */}

                  {/* <div
                    onClick={() => {
                      pageCount > 1 && dispatch(setPagePrev());
                    }}
                    className={`flex  space-x-2 items-center ${
                      pageCount > 1 ? "cursor-pointer" : "text-gray-600"
                    }  `}
                  >
                    <FontAwesomeIcon
                      icon={faArrowAltCircleLeft}
                      className={`flex  space-x-2 items-center ${
                        pageCount > 1 ? "cursor-pointer" : "text-gray-600"
                      }  `}
                    />
                    <div className="font-body">Prev</div>
                  </div> */}

                  {/* <div
                    onClick={() => {
                      dispatch(setPageNext());
                    }}
                    className="flex space-x-2 items-center cursor-pointer"
                  >
                    <div>Next</div>
                    <FontAwesomeIcon icon={faArrowAltCircleRight} />
                  </div> */}
                  {/* <div
                    onClick={() => {
                      pageCount < Math.ceil(totalBookingCount / 10) &&
                        dispatch(setPageNext());
                    }}
                    className={`flex space-x-2 items-center ${
                      pageCount < Math.ceil(totalBookingCount / 10)
                        ? "cursor-pointer"
                        : " text-gray-600"
                    }  `}
                  >
                    <div className="font-body">Next</div>
                    <FontAwesomeIcon
                      icon={faArrowAltCircleRight}
                      className={`flex space-x-2 items-center ${
                        pageCount < Math.ceil(totalBookingCount / 10)
                          ? "cursor-pointer"
                          : " text-gray-600"
                      }  `}
                    />
                  </div> */}
                </div>
              </div>
            </div>
          ) : (
            <div className="lg:flex lg:space-x-5 mx-5 mt-2 justify-between h-screen overflow-y-auto">
              <div className="block managebooking my-5">
                <Calendar
                  className="rounded-md w-72 shadow-lg mt-0"
                  onChange={(date) => {
                    setDateValue(date);
                    setcalenderViewDate(moment(date).format("yyyy-MM-DD"));
                  }}
                  value={dateValue}
                />
              </div>
              <div className="ml-0 md:mt-5">
                <div className="text-lg font-semibold border-b-2 py-1 px-3 mb-3 font-body bg-gray-200">
                  Jobs
                </div>
                <div className="h-[30rem] scrollbar overflow-y-auto lg:w-[675px] xl:w-[600px] pr-10 font-body">
                  <div>
                    {allBookings.map((booking) => {
                      let date = moment(booking.travelDate).format(
                        "DD-MM-YYYY"
                      );
                      let time = booking.travelTime;

                      // let regionTime = momenttz
                      //   .tz(
                      //     `${date} ${time}`,
                      //     "DD-MM-YYYY HH:mm",
                      //     booking?.timeZone
                      //   );
                      let regionTime = momenttz.tz(
                        ` ${time}`,
                        "h:mm A",
                        booking?.timeZone
                      );

                      return (
                        <>
                          {moment(booking.travelDate).format("yyyy-MM-DD") ===
                            calenderViewDate && (
                            <>
                              <div className="flex space-x-5 items-center">
                                <div className="flex items-center space-x-2">
                                  <div
                                    className={`w-3 h-3 rounded-full ${
                                      booking?.affiliateDetails?.affiliateName
                                        ? "bg-teal-500"
                                        : "bg-secondary"
                                    } `}
                                  ></div>

                                  <div className="w-20 ">
                                    <div className="">
                                      <div className="text-xs font-body">
                                        Asia/Kolkata
                                      </div>
                                      <div>
                                        {regionTime
                                          .clone()
                                          .tz("Asia/Kolkata")
                                          .format("h:mm A")}
                                      </div>
                                      <div>
                                        {booking?.affiliateDetails
                                          ?.affiliateName ? (
                                          <div className="font-body text-xs text-teal-500 font-semibold flex items-center space-x-2">
                                            <div className="font-body">
                                              Assigned
                                            </div>
                                            <div>
                                              <FontAwesomeIcon icon={faCheck} />
                                            </div>
                                          </div>
                                        ) : (
                                          <div className="text-xs text-secondary font-semibold flex items-center space-x-2">
                                            <div className=" font-body">
                                              UnAssigned
                                            </div>
                                            <div>
                                              <FontAwesomeIcon
                                                icon={faWarning}
                                              />
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>

                                <div className="space-y-1 py-2">
                                  <CalendarBookingItem
                                    id={booking?.bookingId}
                                    vehicleType={
                                      booking?.vehicleDetails?.categoryType
                                    }
                                    // createdAt={moment(
                                    //   booking?.createdAt
                                    // ).format("yyyy-MM-DD")}
                                    travelAt={moment(
                                      booking?.travelDate
                                    ).format("yyyy-MM-DD")}
                                    // price={
                                    //   Math.round(
                                    //     booking?.priceDetails?.amount
                                    //   ) +
                                    //   " " +
                                    //   booking?.priceDetails?.currency
                                    // }
                                    // passenger_name={
                                    //   booking?.passengerDetails?.firstName +
                                    //   " " +
                                    //   booking?.passengerDetails?.lastName
                                    // }
                                    // company_name={allCompany?.map((company) => {
                                    //   return company?.users?.map((user) => {
                                    //     return (
                                    //       user?.userName ===
                                    //         booking?.userName &&
                                    //       company?.companyName
                                    //     );
                                    //   });
                                    // })}
                                    travel_time={tConvert(booking?.travelTime)}
                                    region={booking?.timeZone}
                                  />
                                </div>
                              </div>
                            </>
                          )}
                        </>
                      );
                    })}
                  </div>
                </div>

                <div className="my-32"></div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default React.memo(ManageBooking);

export const CalendarBookingItem = ({
  id,
  vehicleType,
  createdAt,
  travelAt,
  price,
  passenger_name,
  company_name,
  travel_time,
  affiliate,
  region,
}) => {
  return (
    <Link to={`/manageBooking/${id}`}>
      <div
        className={` border-b-2 lg:w-[18rem] xl:w-[23rem]  text-gray-700 hover:bg-red-200  h-min py-1 px-2 space-x-4  flex text-sm  `}
      >
        <div className="font-semibold lg:w-28 xl:w-36">{id}</div>
        <div className="">
          {vehicleType?.split(" ")[0].slice()[0] +
            "" +
            vehicleType?.split(" ")[1].slice()[0]}
        </div>
        <div className="text-red-700 font-semibold lg:w-20 xl:w-28">
          {travelAt}
        </div>
        <div>
          <div className="text-xs font-body text-blue-600">{region}</div>
          <div className="text-base">{travel_time}</div>
        </div>
      </div>
    </Link>
  );
};

export const SearchItem = ({ label, inputType, onChange, value }) => {
  return (
    <>
      <div className="items-center">
        <div
          className="text-sm w-36 sm:w-36 lg:w-36 text-gray-600 font-body"
          htmlFor=""
        >
          {label}
        </div>
        <input
          type={inputType}
          onChange={onChange}
          value={value}
          className="border border-gray-600 border-b focus:outline-none w-36 xs:w-32 sm:w-auto lg:w-36 text-sm textField font-body"
        />
      </div>
    </>
  );
};
